// Copyright (c) 2016 Deere & Company

export default Object.freeze({
    A_LAYOUT_WITH_THAT_NAME_ALREADY_EXISTS: `Bu ada sahip bir mizanpaj zaten var`,
    ACCEPT: `Kabul Et`,
    ACCEPT_ALL: `Tümünü Kabul Et`,
    ACCEPT_REJECT_TRANSFER_PENDING: `Onay Bekliyor`,
    ACCEPTED: `Kabul Edildi`,
    ACCOUNT: `Hesap`,
    ACCOUNT_ADDRESS: `Hesap Adresi`,
    ACCOUNT_COUNTRY: `Hesap Ülkesi`,
    ACCOUNT_END: `Hesap Sonu`,
    ACCOUNT_NAME: `Hesap Adı`,
    ACCOUNT_NUMBER: `Hesap Numarası`,
    ACCOUNT_NUMBER_REQUIRED: `Gerekli Hesap Numarası`,
    ACCOUNTS: `Hesaplar`,
    ACCUMULATED_DAYS_ON_RENT: `Kiralamada Birikmiş Gün Sayısı`,
    ACCUMULATED_DAYS_RENTED: `Kiralanmiş Birikmiş Gün Sayısı`,
    ACTIONS: `Eylemler`,
    ACTIVE_WARRANTY: `Aktif Garanti`,
    ACTIVE_WARRANTY_CLICK_FOR_DETAIL: `Aktif Garanti (Ayrıntılar için tıklayın)`,
    ACTIVE_WARRANTY_Y_N: `Etkin Garanti (Y/N)`,
    ACTUAL_AMOUNT_OF_USE: `Gerçek Kullanım Miktarı`,
    ACTUAL_AUDIT: `Gerçek Denetim`,
    ACTUAL_AUDIT_DATE: `Gerçek Denetim Tarihi`,
    ACTUAL_COURIER_NAME: `Geçerli Kurye Adı`,
    ACTUAL_H: `Fiili Saat`,
    ACTUAL_HOURS: `Fiili Saat`,
    ACTUAL_PC:`Gerçek Balyalar`,
    ADD_CLAIM: `İddia Ekle`,
    ADD_CLAIMS: `İddialar Ekle`,
    ADD_COMPONENT: `Bileşen Ekle`,
    ADD_OPTION: `Seçenek Ekle`,
    ADD_REP: `Ek Onarım`,
    ADD_TO_AUDIT: `Denetim Ekle`,
    ADDITIONAL: `Ilave`,
    ADDITIONAL_COMMENTS: `Ilave Yorumlar`,
    ADDITIONAL_REPAIR: `Ilave Onarım`,
    ADDITIVE: `Ilave olunacak`,
    ADDRESS: `Adres`,
    ADDRESS_LINE1: `Adres Satırı 1`,
    ADDRESS_LINE1_REQUIRED: `Adres Satırı 1 Gerekli`,
    ADDRESS_LINE2: `Adres Satırı 2`,
    ADJ_CLM: `Talebi Ayarla`,
    ADJUST_CLAIM: `Talebi Ayarla`,
    ADJUSTED_HOURS: `Ayarlanan Saatler`,
    ADJUSTED_QUANTITY: `Düzeltilmiş Miktar`,
    ADJUSTMENT_TYPE: `Ayarlama Türü`,
    ADVANCED_CLAIM_SUMMARY: `Gelişmiş Kleymler Özeti`,
    AFTER_DELIVERY_INSPECTION: `TESLİMAT SONRASI İNCELEME`,
    AGENCY_NAME: `Aracı Adı`,
    ALL: `Tümü`,
    ALL_ACCOUNTS: `Tüm Hesaplar`,
    ALL_CLAIMS: `Tüm İddialar`,
    ALL_CLAIMS_ARE_SUBJECT_TO_REVIEW: `Tüm talepler incelenebilir (daha fazla bilgi için bkz. JD WAM 110.08)`,
    ALL_CLAIMS_TAB: `Tüm İddialar ({count, number})`,
    ALL_PART_REQUESTS: `Tüm Parça İstekleri`,
    ALL_PART_REQUESTS_WITH_COUNT: `Tüm Parça İstekleri ({count})`,
    ALL_PARTS_RETURNED: `İade Edilmiş Tüm Parçalar`,
    AMOUNT: `Tutar`,
    AMOUNT_1: `Tutar 1`,
    AMOUNT_2: `Tutar 2`,
    AMOUNT_3: `Tutar 3`,
    AMOUNT_OF_USE: `Kullanım Miktarı`,
    AMOUNT_OF_USE_ACCEPETD: `Kabul Edilen Kullanım Miktarı`,
    AMOUNT_OF_USE_CREATED_SUCCESSFULLY: `Kullanım Miktarı Başarıyla Oluşturuldu`,
    AMOUNT_OF_USE_HISTORY_WITH_COUNT: `Kullanım Miktarı Geçmişi ({count})`,
    AMOUNT_OF_USE_IS_REQUIRED: `Kullanım Miktarı gereklidir`,
    AMOUNT_OF_USE_REJECTED: `Kullanım Miktarı Reddedildi`,
    AMOUNT_OF_USE_REQUESTS_STATUS: `Kullanım İstekleri Durumu`,
    AMOUNT_OF_USE_REQUESTS_WITH_COUNT: `Kullanım İstekleri Miktarı ({count})`,
    AMOUNT_OF_USE_REQUIRED: `Gereken kullanım miktarı`,
    AMOUNT_OF_USE_UNITS_REQUIRED: `Gereken kullanım birimleri miktarı`,
    AMOUNT_RECORDED: `Kaydedilen Miktar`,
    AMOUNT_TO_BE_DEBITED: `Borçlandırılacak Tutar`,
    APLYPIP: `PIP Uygula`,
    APPLICATION: `Müracaat`,
    APPLICATION_IS_REQUIRED: `Müracaat gereklidi`,
    APPLY: `Uygulamak`,
    APPLY_TRAVEL: `Yolçuluk Uygula`,
    APPROVAL_DEALER_COMMENTS: `Onay Veren Bayi Yorumları`,
    APPROVAL_DETAILS: `Onay Detayları`,
    APPROVAL_LEVELS: `Onay Düzeyleri`,
    APPROVAL_REMARKS: `Onay Açıklamaları`,
    APPROVAL_STATUS: `Onay Durumu`,
    APPROVE: `Onayla`,
    APPROVE_AMOUNT_OF_USE: `Kullanım Miktarını Onayla`,
    APPROVE_LABOR_RATE: `İşçilik Ücretini Onayla`,
    APPROVE_MACHINE_STATUS_UPDATE: `Makine Durumu Güncellemesini Onayla`,
    APPROVE_PIP_CODE_REQUEST: `PIP Kodu İsteyini Onayla`,
    APPROVE_SPECIAL_ALLOWANCE_CLAIM: `Özel Ödenek Talebini Onayla`,
    APPROVED: `ONAYLANDI`,
    APPROVED_CORE_VALUE: `Onaylanan Temel Değer`,
    APPROVED_DATE_CANNOT_BE_BEFORE_SETUP_DATE: `Onaylı tarih, kurulum tarihinden önce olamaz`,
    APPROVED_DIAGNOSTIC_AMOUNT: `Onaylanan Teşhis Miktarı`,
    APPROVED_DIAGNOSTIC_HOURS: `Onaylanmış Teşhis Saatleri`,
    APPROVED_IS_REQUIRED: `Onaylı gereklidir`,
    APPROVED_LABOR_ADDITIVE: `Onaylanan İşçilik İlavesi`,
    APPROVED_LABOR_AMOUNT: `Onaylanan İşçilik Tutarı`,
    APPROVED_LABOR_HOURS: `Onaylanan İşçilik Saati`,
    APPROVED_LABOR_TOTAL: `Onaylanan İşçilik Toplamı`,
    APPROVED_ON_SHELF_COST: `Onaylanan Raf Maliyeti`,
    APPROVED_OTHER_CREDITS: `Onaylanan Diğer Alacaklar`,
    APPROVED_PARTS: `Onaylanan Parçalar`,
    APPROVED_PARTS_ADDITIVE: `Onaylanan Parça İlavesi`,
    APPROVED_PARTS_TOTAL: `Onaylanan Parça Toplamı`,
    APPROVED_REJECTED: `Onaylandı/Reddedildi`,
    APPROVED_REPAIR_AMOUNT: `Onaylı Onarım Tutarı`,
    APPROVED_REPAIR_HOURS: `Onaylı Tamir Saatleri`,
    APPROVED_TAXES_TOTAL: `Onaylanan Vergi Toplamı`,
    APPROVED_TRAVEL_TOTAL: `Onaylanan Seyahat Toplamı`,
    APPROVER: `Onaylayan`,
    ASCENDING: `yükselen (artan)`,
    ATTACHMENTS: `Ekler`,
    AUDIT_NUMBER: `Denetim Numarası`,
    AUDIT_PLANNED: `Planlanan Denetim`,
    AUDIT_REQUIREMENT: `Denetim Gerekliliği`,
    AUDIT_RESULTS: `Denetim Sonuçları`,
    AUDIT_STATUS: `Denetim Durumu`,
    AUDIT_SUBMITTED_SUCCESSFULLY: `Denetim Başarıyla Gönderildi`,
    AUDIT_SUMMARY: `Denetim Özeti`,
    AUDIT_TYPE: `Denetim türü`,
    AUDITS: `Denetimler`,
    AUDITS_DUE_WITH_COUNT: `{countToDisplay} denetimin süre sonu`,
    AUDITS_DUE_WITHIN_30_DAYS: `{countToDisplay} {count, plural, one {audit} other {audits}} 30 gün içinde sona eriyor`,
    AUDITS_PAST_DUE_WITH_COUNT: `{countToDisplay} {count, plural, one {audit} other {audits}} süre sonu geçmiş`,
    AUTHORIZATION_NUMBER: `Yetki Numarası`,
    AUTO_SUBMIT_FROM_DEALER_BUSINESS_SYSTEM: `Bayi İş Sisteminden Otomatik Gönder`,
    AVAILABLE: `MEVCUT`,
    AVAILABLE_COLUMNS: `Sütunları Mevcut`,
    AVERAGE_DIAGNOSTICS_HOURS: `Ortalama Diyagnostik Süresi (Saat cinsinden)`,
    AVERAGE_LUG_HEIGHT: `Ortalama Bijon Yüksekliği`,
    AVERAGE_LUG_HEIGHT_IS_REQUIRED: `Ortalama Lug Yüksekliği gereklidir`,
    AVERAGE_REPAIR_HOURS: `Ortalama Tamir Süresi (Saat cinsinden)`,
    AVERAGE_REPLACEMENT_HOURS: `Ortalama Değişiklik Süresi (Saat cinsinden)`,
    AVERAGE_TECH_PAY_RATE: `Ortalama Teknisyen Maaş Oranı`,
    BACK: `Geri`,
    BACK_TO_AUDIT: `Denetime Geri Dön`,
    BASE_MACHINE: `Base Machine`,
    BASE_MACHINE_IMPLEMENTS: `Temel Makine Ekipmanları`,
    BASE_MACHINE_PIN: `Temel Makine PIN`,
    BASIC_WARRANTY_ENDS: `Temel Garanti Bitişi`,
    BASIC_WARRANTY_ESTIMATOR: `Temel Garanti Tahmin Edici`,
    BASIC_WARRANTY_STARTS: `Temel Garanti Başlangıcı`,
    BASIS_FOR_SETTLEMENT: `Yerleşim icin Temel`,
    BASIS_FOR_SETTLEMENT_AUDIT_COMMENTS: `Yerleşim icin Temel / Denetim Yorumları`,
    BASIS_FOR_SETTLEMENT_IS_REQUIRED: `Yerleşim icin Temel gereklidir`,
    BATTERY: `AKÜ`,
    BEGIN_DATE: `Başlangıç Tarihi`,
    BRANCH: `Şube`,
    BUILT: `Derleme`,
    BUSINESS_END: `İş Sonu`,
    CAN_THE_MACHINE_BE_PUT_BACK_INTO_SERVICE: `Makine tekrar hizmete sokulabilir mi?`,
    CANCEL: `İptal`,
    CERTIFIED_LETTER_SENT: `Onaylı Mektup Gönderildi`,
    CGST: `CGST`,
    CHANGE_RESPONSIBLE_DEALER: `Sorumlu Bayiyi Değiştir`,
    CHANGE_STATUS: `Durumu Değiştir`,
    CHANGE_STATUS_FOR: `{pin} için Değişiklik Durumu`,
    CHANGED: `Değiştirildi`,
    CHANGED_BY: `Değiştiren`,
    CHANGED_ON: `Değişiklik Tar.`,
    CHINESE: `Çince`,
    CITY: `Şehir`,
    CITY_REQUIRED: `Şehir Gerekli`,
    CLAIM: `Kleym`,
    CLAIM_COUNT_WITH_PARENTHESIS: `({countToDisplay} {count, plural, one {Claim} other {Claims}})`,
    CLAIM_DEBIT: `İddia Borcu`,
    CLAIM_DETAILS: `İddia Detayları`,
    CLAIM_DRAFT: `TASLAK`,
    CLAIM_HISTORY: `24 aylik iddia tarixi`,
    CLAIM_HISTORY_WITH_COUNT: `24 aylik iddia tarixi ({count})`,
    CLAIM_NUMBER: `İddia Numarası`,
    CLAIM_RECOVER_PERCENTAGE: `(%{percentage})`,
    CLAIM_SEARCH: `İddia Araması`,
    CLAIM_STATUS: `İddia Durumu`,
    CLAIM_TYPE: `İddia Türü`,
    CLAIM_TYPES: `Kleym Türleri`,
    CLAIM_UPDATED_SUCCESSFULLY: `Kleym Başarıyla Güncellendi`,
    CLAIM_VALUE: `İddia Değeri`,
    CLAIM_VALUE_DETAILS: `Kleym Değeri Detayları`,
    CLAIM_WITH_NUMBER: `Kleym {claimNumber}`,
    CLAIMS: `İddialar`,
    CLAIMS_IN_PROGRESS: `İddialar Devam Ediyor`,
    CLAIMS_IN_PROGRESS_WITH_COUNT: `İddialar Devam Ediyor ({count})`,
    CLAIMS_OVERVIEW: `İddialara Genel Bakış`,
    CLAIMS_OVERVIEW_TAB: `İddialara Genel Bakış ({count})`,
    CLAIMS_WITH_COUNT: `İddia {count}`,
    CLICK_FOR_DETAILS: `(Detaylar için tıklayın)`,
    CLICK_TO_VIEW_ALL: `Tümünü Görüntülemek İçin Tıkla`,
    CLOSE: `Kapat`,
    CLOSED_PART_REQUESTS: `Kapalı Parça Talepleri`,
    CLOSING: `Kapanış`,
    CLOSING_ACCOUNT: `Kapanış Hesabı`,
    CLOSING_ACCOUNT_WITH_COUNT: `Kapanış hesabı ({count})`,
    CODE: `Kod`,
    COLLAPSE_ALL: `Tümünü Daralt`,
    COMMENT: `Yorum`,
    COMMENTS: `Yorumlar`,
    COMMENTS_IS_REQUIRED: `Yorumlar gereklidir`,
    COMMENTS_TO_DEALER: `Bayi Yorumları`,
    COMMON_LABOR_TYPES_WARNING: `Seçilen hesaplar için tüm İşçilik türleri kullanılamaz`,
    COMPANY: `Şirket`,
    COMPANY_CONTRIBUTION: `Şirket Katkısı`,
    COMPANY_CONTRIBUTION_IS_REQUIRED: `Şirket Katkısı Gereklidir`,
    COMPLAINT_CAUSE: `Şikayetin tanısı neydi?`,
    COMPLAINT_CAUSE_IS_REQUIRED: `Şikayet diyagnostiği gereklidir`,
    COMPLAINT_CORRECTION: `Şikayet nasıl onarıldı?`,
    COMPLAINT_CORRECTION_IS_REQUIRED: `Reparation av klagomål krävs`,
    COMPLETE: `Tamamlandı`,
    COMPLETED: `Tamamlandı`,
    COMPLETED_BY: `Tamamlayan`,
    COMPLETED_DATE: `Tamamlama Tarihi`,
    COMPLETED_IN_LAST_24_MONTHS: `Son 24 Ayda Tamamlanan`,
    COMPLETION_STATUS: `Tamamlama Durumu`,
    COMPONENT: `Bileşen`,
    COMPONENT_CODE: `Bileşen Kod`,
    COMPONENT_CREATED_SUCCESSFULLY: `Bileşen Başarıyla Yaratıldı`,
    COMPONENT_DELETED_SUCCESSFULLY: `Bileşen Başarıyla Silindi`,
    COMPONENT_SERIAL_NUMBER: `Bileşen Seri Numarası`,
    COMPONENT_SUCCESSFULLY_UPDATED: `Bileşen Başarıyla Güncellendi`,
    COMPONENTS: `Bileşenler`,
    CONFIRM: `Tasdik etmek`,
    CONFIRM_ADDITIONAL_REPAIR: `İlave tamir eklemek istediğiniden emin misiniz?`,
    CONFIRM_ADJUST_CLAIM: `Bu Talebi ayarlamak istediğiniden emin misiniz?`,
    CONFIRM_CLOSING_ACCOUNT: `Bu transferi kabul etmek istediğinizden emin misiniz?`,
    CONFIRM_COPY_CLAIM: `Bu Talebi kopyalamak istediğinizden emin misiniz?`,
    CONFIRM_DELETE_ATTACHMENT: `Ekli dosyayı silmek istediğinizden emin misiniz?`,
    CONFIRM_DELETE_CLAIM: `Bu Talebi silmek istediğinizden emin misiniz?`,
    CONFIRM_DELETE_MACHINE_STATUS_UPDATE: `Bu Makine Durumu İsteğini silmek istediğinizden emin misiniz?`,
    CONFIRM_DELETE_REGISTRATION: `Bu Kaydı silmek istediğinizden emin misiniz?`,
    CONFIRM_EDIT_CLAIM: `Bu iddiayı gerçekten değiştirmek istiyor musunuz?`,
    CONFIRM_RECONCILE_CLAIM: `Bu Talebi karşılaştırmak istediğinizden emin misiniz?`,
    CONFIRM_RESEND_XML: `XML'yi yeniden göndermek istediğinizden emin misiniz? Lütfen 24-48 saat içinde görünür olmasına izin verin.`,
    CONFIRM_SKIP_AUDIT: `Bu Talebi atlamak istediğinize emin misiniz?`,
    CONFIRM_UNDO_REGISTRATION: `Bu Kaydı geri almak istediğinizden emin misiniz?`,
    CONFIRM_UNRECONCILE_CLAIM: `Bu Talebin mutabakatını kaldırmak istediğinizden emin misiniz?`,
    CONNECTED_MACHINE: `Bağlı Makine`,
    CONTACTED: `İletişim Kuruldu`,
    CONTAINS: `İçerik`,
    CONTRACT_NUMBER: `Sözleşme Numarası`,
    CONTRACT_PURCHASED: `Satın Alınan Sözleşme`,
    CONTRACT_TYPE: `Sözleşme Türü`,
    COPY_CLAIM: `Talebi Kopyala`,
    CORE: `Esas`,
    CORE_VALUE: `Esas Değer`,
    COUNTRY: `Ülke`,
    COUNTRY_REQUIRED: `Ülke Gerekli`,
    COURIER_ACCOUNT_NUMBER: `Kurye Hesap Numarası`,
    COURIER_NAME: `Kurye Adı`,
    COVERAGE_DECISION: `Kapsam Kararı`,
    COVERAGE_TYPE: `Kapsam Türü`,
    CRDMEM: `Alacak Dekontu`,
    CREATE: `Oluştur`,
    CREATE_CLAIM: `İddia Yarat`,
    CREATE_LAYOUT: `Mizanpaj Oluştur`,
    CREATE_NON_TRACKED_PIN_HELP_TEXT: `Bu ürüne ilişkin bir taleb dosyalamadan önce buna ilişkin bazı bilgileri bizimle paylaşmanız gerekir`,
    CREATE_PIP_CLAIM: `PIP Talebi Oluştur`,
    CREATE_PIP_CLAIMS: `PIP Talepleri Oluştur`,
    CREATE_PRODUCT_RECORD: `Ürün Kaydı Oluştur`,
    CREATE_REQUEST: `Talep Oluştur`,
    CREATE_TRANSFER_PENDING: `Aktarım Bekliyor`,
    CREATE_TRANSFER_SERVICE_UNAVAILABLE: `Transfer Hizmetleri Oluşumu Kullanılamiyor`,
    CREATED: `Oluşturuldu`,
    CREATED_BY: `Oluşturan`,
    CREATED_DATE: `Oluşturulma Tarihi`,
    CREATED_DATE_FROM: `Oluşturma Tarihinden`,
    CREATED_DATE_TO: `Oluşturulma Tarihine`,
    CREATED_ON: `Oluşturma`,
    CREATION_DATE: `Oluşturma Tarihi`,
    CREDIT_MEMO: `Alacak Dekontu`,
    CREDIT_MEMO_DATE: `Alacak Dekontu Tarihi`,
    CREDIT_MEMO_ISSUE_DATE: `Alacak Dekontu Verildi`,
    CREDIT_MEMO_NUMBER: `Alacak Dekontu Numarası`,
    CREDIT_MEMO_PROCESS_DATE: `Alacak Dekontu İşlendi`,
    CREDIT_MEMO_SELECTED: `Alacak Dekontu Seçildi`,
    CREDIT_MEMOS: `Alacak Dekontları`,
    CRITERIA: `Kriterler`,
    CRT: `Oluştur`,
    CSV_SEPARATOR: `CSV Ayırıcı`,
    CURRENCY: `Para Birimi`,
    CURRENT: `Mevcut`,
    CURRENT_ACCOUNT: `Mevcut Hesap`,
    CURRENT_AMOUNT_OF_USE: `Mevcut Kullanım Miktarı`,
    CURRENT_CUSTOMER: `Geçerli Müşteri`,
    CURRENT_DEALER: `Mevcut Bayi`,
    CURRENT_DEALER_DISTANCE: `Geçerli Satıcı Uzaklığı`,
    CURRENT_DEALER_LAST_SERVICE_DATE: `Geçerli Satıcı Son Servis Tarihi`,
    CURRENT_DEALER_LOCATION: `Geçerli Bayi Konumu`,
    CURRENT_HOURS: `Geçerli Saatler`,
    CURRENT_QUANTITY: `Geçerli Miktar`,
    CURRENT_RESPONSIBLE_DEALER: `Geçerli Sorumlu Satıcı`,
    CURRENT_VALUES: `Geçerli Değerler`,
    CURRENTLY_ON_RENT: `Halen Kirada`,
    CUSTOM_RANGE: `Özel Aralık`,
    CUSTOM_VALUES: `Özel Değerler`,
    CUSTOMER: `Müşteri`,
    CUSTOMER_CONTRIBUTION: `Müşteri Katkısı`,
    CUSTOMER_CONTRIBUTION_IS_REQUIRED: `Müşteri Katkısı Gereklidir`,
    CUSTOMER_CREATED_SUCCESSFULLY: `Müşteri başarıyla oluşturuldu`,
    CUSTOMER_DETAILS: `Müşteri Detayları`,
    CUSTOMER_DETAILS_UPDATED_SUCCESSFULLY: `Müşteri detayları başarıyla güncellendi`,
    CUSTOMER_INFORMATION: `Müşteri Bilgileri`,
    CUSTOMER_INFORMATION_IS_REQUIRED: `Müşteri bilgisi gerekiyor.`,
    CUSTOMER_INVALID: `Müşteri geçersiz`,
    CUSTOMER_NAME: `Müşteri Adı`,
    CUSTOMER_NAME_IS_REQUIRED: `Müşteri bilgisi gerekiyor.`,
    CUSTOMER_NOT_FOUND: `Müşteri Bulunamadı`,
    CUSTOMER_REQUIRED: `Gereken müşteri`,
    CUSTOMER_RESOLUTION: `Müşteri Çözümü`,
    CUSTOMER_RESOLUTION_IS_REQUIRED: `Müşteri Çözümü Gereklidir`,
    CUSTOMER_SEARCH: `Müşteri Araması`,
    CUSTOMER_UPDATED_SUCCESSFULLY: `Müşteri başarıyla güncellendi`,
    DAMAGED_MACHINES_HELP_TEXT: `Hasarlı makineler için garanti otomatik olarak askıya alınır, ta ki bu form gözden geçirilene ve garanti yeniden verilmek üzere TCSM tarafından onaylanana kadar. Hasarlı makineler sadece Zorunlu ve Güvenlik PIP'leri için yeterlidir.`,
    DATE: `Tarih`,
    DATE_FORMAT: `Tarih Biçimi`,
    DATE_ISSUED: `Yayımlama Tarihi`,
    DATE_OF_CERTIFIED_LETTER: `Onaylı Mektub Tarihi`,
    DATE_OF_EVENT_CAUSING_DAMAGE: `Hasara neden olan olay tarihi`,
    DATE_OF_LAST_PERSONAL_CONTACT: `Son Özel İrtibat Tarihi`,
    DATE_RECALLED_PART_WAS_SHIPPED_SENT: `Geri Çağrılan Parçanın Sevk Edildiği/Gönderildiği Tarih`,
    DATE_REFUSED: `Reddedilme Tarihi`,
    DATE_SUBMITTED: `Gönderme Tarihi`,
    DAYS_FROM_REGISTRATION: `Kayıttan sonraki gün sayısı`,
    DAYS_LEFT: `Kalan Gün`,
    DAYS_LEFT_WITH_COUNT: `{daysToDisplay} Gün kaldı`,
    DAYS_ON_RENT: `Kiradaki Gün Sayısı`,
    DAYS_REMAINING: `Kalan Gün Sayısı`,
    DAYS_REMAINING_WITH_COUNT: `{daysToDisplay} {days, plural, one {Day} other {Days}} Kaldı`,
    DAYS_SINCE_RECOMMENDATION: `{daysToDisplay} {days, plural, one {Gün} other {Gün}} Öneri`,
    DAYS_TO_DISPLAY: `Görüntülenecek Gün Sayısı`,
    DBS: `DBS`,
    DEALER: `Bayi`,
    DEALER_ACCOUNT: `Bayi Hesabı`,
    DEALER_ACCOUNT_IS_REQUIRED: `Bayi Hesabı gereklidir`,
    DEALER_ACCOUNTS: `Bayi Hesapları`,
    DEALER_CITY: `Bayi Şehri`,
    DEALER_COMMENTS: `Bayi Yorumları`,
    DEALER_CONTRIBUTION: `Bayi Katkısı`,
    DEALER_CONTRIBUTION_IS_REQUIRED: `Bayi Katkısı Gereklidir`,
    DEALER_HIERARCHY_ACCOUNT: `{account} ({industryIndicator})`,
    DEALER_INVOICE_NUMBER: `Bayi Fatura Numarası`,
    DEALER_INVOICE_UPDATED: `BAYİ FATURASI GÜNCELLENDİ`,
    DEALER_INVOICE_UPDATES: `Bayi Faturası`,
    DEALER_INVOICES: `Bayi Faturaları`,
    DEALER_LOCATION: `Bayi Konumu`,
    DEALER_LOCATION_FILTER: `Konumları Filtrele`,
    DEALER_LOCATION_IS_REQUIRED: `Bayi Konumu gereklidir`,
    DEALER_LOCATIONS: `Bayi Konumları`,
    DEALER_NAME: `Bayi Adı`,
    DEALER_PHONE: `Bayi Telefon No`,
    DEALER_POSTAL_CODE: `Posta Kodu`,
    DEALER_RECOMMENDATIONS: `Satıcı Önerileri`,
    DEALER_RECOMMENDATIONS_TAB: `Satıcı Önerileri ({count})`,
    DEALER_REVIEW_REQUEST_SUCCESSFULLY: `Satıcı Başarıyla Gözden Geçirildi`,
    DEALER_SEARCH: `Bayi Arama`,
    DEALER_SEARCH_CHOOSE_CITY_NAME_ACCOUNT: `Bayileri aramak için Adı, Şehri veya Hesabı girin`,
    DEALER_STATE: `Bayi, Vilayet/İlçe`,
    DEALER_SUBMISSION_WITH_CURRENCY: `Bayi Gönderimi ({currency})`,
    DEALER_TRANSFER_HISTORY: `Bayi Transfer Geçmişi`,
    DEALER_TRANSFER_REQUEST_PARTIALLY_SUCCESSFUL: `Bazı Transfer İstekleri başarıyla oluşturuldu. Bireysel olarak kalan işlemi yapın.`,
    DEALER_TRANSFER_REQUEST_SUCCESSFULLY: `Satıcı Transfer Talebi Başarıyla Sıraya Alındı`,
    DEALER_WARRANTY: `Bayi Garantisi`,
    DEALERS: `Bayiler`,
    DEALERSHIP: `Bayilik`,
    DEBIT: `Borç`,
    DEBIT_AMOUNT: `Borç Miktarı`,
    DEBIT_FOR_CLAIM_NUMBER: `{claimNumber} Borcu`,
    DEBIT_REQUIRED: `Kleym Edilen Borç`,
    DEBIT_REQUIRED_STATUS: `Kleym Edilen Borç Durumu`,
    DEBIT_SUBMITTED_SUCCESSFULLY: `Borç Başarıyla Gönderildi`,
    DEBIT_TYPE: `Borç türü`,
    DEBITED: `Borçlandırılacak`,
    DEBITS_TO_THIS_CLAIM_MUST_BE_COMPLETED_THROUGH_MANUAL_DEBIT_PROCESS: `Bu iddiaya ait borçların, manuel borç süreci aracılığıyla tamamlanması gerekir`,
    DECIMAL_FORMAT: `Ondalık Format`,
    DECISION_UPDATED: `Karar Güncellendi`,
    DECLINE: `Reddet`,
    DEDUCTIBLE: `İndirim`,
    DEERE_REMARKS: `Deere Açıklamaları`,
    DEFAULT_WARRANTY: `Varsayılan Garanti`,
    DEL: `Sil`,
    DELETE: `Sil`,
    DELETE_ATTACHMENT: `Eki Sil`,
    DELETE_CLAIM: `Talebi Sil`,
    DELETE_MACHINE_STATUS_UPDATE: `Makine Durum Güncellemesini Sil`,
    DELETE_MACHINE_STATUS_UPDATE_SUCCESS: `Makine Durumu Silme Başarılı`,
    DELETE_REGISTRATION: `Kaydı Sil`,
    DELETE_REGISTRATION_SUCCESS: `Kayıt Silme Başarılı`,
    DELETED: `SİLİNDİ`,
    DELETED_BY: `Tarafından Silindi`,
    DELIVERED: `Teslim Edildi`,
    DELIVERED_IS_REQUIRED: `Teslim Edildi gereklidir`,
    DELIVERY_DATE: `Teslim Tarihi`,
    DELIVERY_DATE_REQUIRED: `Teslim Tarihi gerekli`,
    DELIVERY_DATES: `Teslimat Tarihleri`,
    DELIVERY_NO_DOCUMENTS: `Teslimat Numarası Belgeleri`,
    DEMO_RENTAL_BEGIN_DATE: `Demo/Kiralama Başlangıç Tarihi`,
    DEMO_RENTAL_CHOOSE_DEALERS_STATUS: `Bayileri ve Durumu Seç`,
    DEMO_RENTAL_END_DATE: `Demo/Kiralama Bitiş Tarihi`,
    DEMO_RENTAL_HISTORY: `Demo Kiralama Geçmişi`,
    DENY: `Reddet`,
    DENY_AMOUNT_OF_USE: `Kullanım Miktarını Reddet`,
    DENY_MACHINE_STATUS_UPDATE: `Makine Durumu Güncellemesini Reddet`,
    DENY_PIP_CODE_REQUEST: `PIP Kodu Talebini Reddet`,
    DESCENDING: `eksilen (azalan)`,
    DESCRIPTION: `açıklama`,
    DESCRIPTION_OF_DAMAGE: `Hasarın açıklaması`,
    DESCRIPTION_OF_EVENT_CAUSING_DAMAGE: `Hasara neden olan olayın açıklaması`,
    DESELECT_ALL: `Tüm Seçimleri Kaldır`,
    DETAILS: `Detaylar`,
    DIAGNOSTICS_COVERED: `Kapsam Dahilindeki Diyagnostikler`,
    DIS_VSR: `Mesajları Görüntüle`,
    DISPLAY: `Görüntüle`,
    DISPLAY_CLAIM: `Kleymi Görüntüle`,
    DISPLAY_CREDIT_MEMO: `Alacak Dekontunu Görüntüle`,
    DISPLAY_FORMAT: `Ekran Formatı`,
    DISPLAY_PRODUCT: `Ürün Görüntüle`,
    DISPLAY_TAG: `Etiketi Görüntüle`,
    DISTANCE: `Mesafe`,
    DISTANCE_FROM_CURRENT_DEALER: `Geçerli Satıcıdan Uzaklık`,
    DISTANCE_FROM_POTENTIAL_DEALER: `Potansiyel Satıcıdan Uzaklık`,
    DISTANCE_FROM_RESPONSIBLE_ACCOUNT: `Sorumlu Hesaptan Uzaklık`,
    DIVISION: `Bölüm`,
    DIVISION_SUMMARY: `Bölüm Özeti`,
    DO_YOU_WANT_TO_SAVE_YOUR_CHANGES: `Değişikliklerinizi kaydetmek istiyor musunuz?`,
    DOES_NOT_CONTAIN: `Içermiyor`,
    DOWNLOAD_TO_EXCEL: `Excel'e İndir`,
    DOWNTIME: `Çalışmama Süresi`,
    DOWNTIME_IS_REQUIRED: `Çalışmama Süresi gereklidir`,
    DRAFT: `Taslak Olarak Kaydet`,
    DTAC_CASE: `DTAC Vakası`,
    DTAC_CASE_NUMBER: `DTAC Vaka Numarası`,
    DTAC_SOLUTION: `DTAC Çözümü`,
    DUE_DATE: `Vade Tarihi`,
    DUE_WITHIN_3_MONTHS: `3 Ay İçinde Sona Eriyor`,
    DUPLICATE_PIN_PLATE: `Yinelenen PIN Plakası`,
    DUPLICATE_PIN_PLATE_REPORT: `Yinelenen PIN Plakası Raporu`,
    DUPLICATE_PIN_PLATE_REQUEST_UPDATED: `Yinelenen PIN Plakası İsteği Güncellendi`,
    DUPLICATE_PIN_PLATE_SUCCESSFULLY_CREATED: `Yinelenen PIN Plakası İsteği Başarıyla Oluşturuldu`,
    DUPLICATE_PIN_PLATE_WITH_COUNT: `Yinelenen PIN Plakası İsteği ({count})`,
    EDIT: `Düzenle`,
    EDIT_CUSTOMER: `Müşteriyi Düzenle`,
    EDIT_LAYOUT: ` Mizanpaj Düzenle`,
    EDIT_WITH_PARENTHESES: `(Düzenle)`,
    EFFECTIVE: `Geçerli`,
    EFFECTIVE_DATE: `Geçerlilik Tarihi`,
    EMAIL: `E-posta`,
    EMISSIONS_PART_SEARCH: `Emisyon Parça Araması`,
    END_DATE: `Bitiş Tarihi`,
    END_USE: `Kullanım Sonu`,
    END_USE_CODE: `Son Kullanıcı Kodu`,
    END_USE_CODE_REQUIRED: `Gereken Kullanım Sonu Kodu`,
    ENDS_WITH: `Bununla biter`,
    ENGLISH: `ingilizce`,
    ENTER_A_NUMBER_BETWEEN_0_AND_1000: `0 ve 1000 arasında bir sayı girin`,
    ENTER_A_NUMBER_BETWEEN_0_AND_10000: `0 ila 10000 arasında bir sayı girin`,
    ENTER_A_NUMBER_FROM_1_TO_9999: `1 ila 9999 arasında bir sayı girin`,
    ENTER_A_PART_NUMBER: `Parça Numarasını Girin`,
    ENTER_COMMENTS_BEFORE_ACCEPTING: `Kabul etmeden önce yorumları girin`,
    ENTITY_ID: `Varlık Kimliği`,
    EQUALS: `Eşitlikler`,
    ERROR: `HATA:`,
    ERROR_MESSAGE_TITLE: `Bir hata oluştu:`,
    ERROR_MESSAGES: `Hata Mesajları`,
    ERROR_MESSAGES_TITLE: `Birden fazla hata oluştu:`,
    ERROR_NETWORK_ISSUES: `Bir şebeke hatası, verilerin yüklenmesini önledi, lütfen yeniden deneyin`,
    ERROR_NO_DATA_TO_EXPORT: `Dışarı aktarılacak veri yok`,
    ERROR_RETRIEVING_CUSTOMER_INFORMATION: `Müşteri bilgileri alınırken hata oluştu`,
    ERROR_SAP: `Sunucuya bağlanılamıyor.  Sorun devam ederse sorununuzu çözmede yardım almak için "Bize Ulaşın" bağlantısını kullanın.`,
    ERROR_SESSION: `Oturumunuzun süresi doldu.  Tekrar oturum açmak için sayfayı yenileyin.`,
    ERROR_UNHANDLED: `Sistem, beklenmedik bir hata ile karşılaştı.  Sorun devam ederse sorununuzu çözmede yardım almak için lütfen "Yardım" özelliğini ya da "Bize Ulaşın" bağlantısını kullanın.`,
    ERROR_UPLOADING_FILE: `Dosya eklenmedi`,
    ESTIMATED_BASIC_DATE: `Tahmini Temel Tarih`,
    ESTIMATED_BASIC_DAYS: `Tahmini Temel Gün Sayısı`,
    ESTIMATED_HOURS: `Tahmini Saat Sayısı`,
    ESTIMATES_MAY_NOT_REFLECT_DEMO_STATUS_OR_HOURS_NOT_YET_REPORTED: `Tahminler demo durumunu yansıtmayabilir veya saat henüz raporlanmamıştır`,
    EXCEEDS_DEMO_THRESHOLD: `Demo Eşiğini Aşıyor`,
    EXCHANGE_RATE: `Döviz kuru`,
    EXCLUDED_PINS_ARE_NOT_INCLUDED_IN_THIS_REPORT: `Hariç tutulan PIN'ler bu rapora dahil edilmedi.`,
    EXECUTE: `Yürüt`,
    EXPAND_ALL: `Tümünü Genişlet`,
    EXPECTED_FIRST_USE: `Beklenen İlk Kullanım`,
    EXPIRATION_DATE: `Sona erme tarihi`,
    EXPIRED: `Kullanım Süresi Dolmuş`,
    EXPIRED_PART_REQUESTS: `Süresi dolan parça talepleri`,
    EXPIRED_PIPS: `Süresi dolan PIP'ler`,
    EXPIRES: `Son Kullanma Tarihi`,
    EXPIRING_SOON: `Süresi Yakında Doluyor`,
    EXPORT: `İhracat`,
    EXTENDED_WARRANTY: `Uzatılmış Garanti`,
    FACTORY: `FABRİKA`,
    FACTORY_DUPLICATE_PIN_PLATE: `Yinelenen PIN Plakası`,
    FACTORY_NAME: `Fabrika Adı`,
    FACTORY_USERS_TAB: `Yinelenen PIN Plakası ({count})`,
    FAILED: `Başarısız`,
    FAILED_AREA: `Başarısız Alan`,
    FAILED_AREA_IS_REQUIRED: `Başarısız Alanı gereklidir`,
    FAILED_DATE: `Başarısız Tarihi`,
    FAILED_DATE_IS_REQUIRED: `Başarısız Tarihi gereklidir`,
    FAILED_MODE: `Başarısız Modu`,
    FAILED_MODE_COMMENTS: `Başarısız Modu Yorumları`,
    FAILED_PART: `Arızalı Parça`,
    FAILED_PART_DESCRIPTION: `Arızalı Parça Açıklaması`,
    FAILED_PART_IS_A_REMAN_PART: `Arızalı Parça bir ReMan Parça`,
    FAILED_PART_IS_REQUIRED: `Arızalı Parça gereklidir`,
    FAILED_PART_SERIAL: `Arızalı Parça Seri Numarası`,
    FAILED_PART_SERIAL_IS_REQUIRED: `Arızalı Parça Seri Numarası gereklidir`,
    FAILURE_DATE: `Arıza Tarihi`,
    FAILURE_INFORMATION: `Arıza Bilgisi`,
    FAILURE_MODE: `Arıza Modu`,
    FAILURE_MODE_IS_REQUIRED: `Başarısız Mod gereklidir`,
    FAILURE_PART: `Arızalı Parça`,
    FAILURE_PART_DESCRIPTION: `Arızalı Parça Açıklaması`,
    FAILURE_PART_IS_REQUIRED: `Arızalı parça gerekli`,
    FAILURE_TO_RETURN_PARTS_WARNING: `Talep edilen parçaların iade edilmemesi bir borçlanmaya neden olabilir.`,
    FAVORITES: `Sık kullanılanlar`,
    FILE_NAME: `Dosya Adı`,
    FILE_SIZE_IS_TOO_BIG: `Dosya Boyutu çok Büyük (Maksimum Boyut: 100 MB)`,
    FILE_SIZE_IS_TOO_BIG_CSV: `Dosya Boyutu çok Büyük (Maksimum Boyut: 1 MB)`,
    FILE_UPLOAD_MESSAGE: `Dosyaları Buraya Bırak veya Dosyaları Ekle (Maksimum Boyut: 100 MB)`,
    FILE_UPLOAD_MESSAGE_CSV: `Dosyaları Buraya Bırak veya Dosyaları Ekle (Maksimum Boyut: 1 MB)`,
    FILE_UPLOAD_MESSAGE_IMAGE: `Resim Buraya Bırak veya Resim Ekle (Maksimum Boyut: 100 MB).`,
    FILE_UPLOAD_MESSAGE_SINGLE: `Buraya Tek Bir Dosya Bırakın veya Ekle'ye Tıklayın (Maksimum Boyut: 100 MB)`,
    FILE_UPLOAD_UNABLE_TO_READ: `Sistem dosyanızı okuyamadı.  Lütfen şablonu şablonla karşılaştırın ve yeniden deneyin.`,
    FILES: `Dosyalar`,
    FILTER_DEALER_RECOMMENDATIONS_MESSAGE: `Sonuç yok. Tüm önerileri aramak için Enter tuşuna basın.`,
    FILTER_PLACEHOLDER: `Filtre Sonuçları`,
    FILTER_WITH_ELLIPSIS: `Filtre`,
    FILTERED_BY_COLUMN_ID: `Filtreleyen: {columnId}`,
    FIND_CUSTOMER: `Müşteri Bul`,
    FINNISH: `Fince`,
    FIRST_MAINTENANCE: `İLK BAKIM`,
    FIRST_NAME: `Adı`,
    FIRST_NAME_IS_REQUIRED: `Ad gereklidir`,
    FIRST_SHIP_TO_LOCATION: `İlk Sevk Yeri Konumu`,
    FIRST_USE: `İlk Kullanım`,
    FISCAL_YEAR: `Mali Yıl`,
    FLUID_SAMPLING_REQUIRED: `Akışkan Örneği Gerekiyor`,
    FORWARDED: `İLETİLDİ`,
    FRENCH: `Fransızca`,
    FRWRD: `İlet`,
    FULL_DEBIT: `Tam Borç`,
    GENERAL: `Genel`,
    GERMAN: `Almanca`,
    GET_MAINTENANCE_PLANS: `Bakım Planlarını Al`,
    GOODS_INSTALLATION_VAT: `Ürün Kurulumu KDV'si`,
    GRACE_PERIOD: `Ücretsiz Kullanım Süresi`,
    GREATER_THAN: `Daha büyük`,
    GREATER_THAN_OR_EQUALS: `Daha büyük veya eşitlik`,
    GROUP_COMPLETE: `Grup Tamamlandı`,
    GST_PERCENTAGE: `GST Yüzde`,
    H_LIMIT: `Saat Sınırı`,
    HISTORY_TO_DISPLAY: `Görüntülenecek geçmiş (gün)`,
    HOME: `Ev`,
    HOUR_LIMIT: `Saat Sınırı`,
    HOURS: `Saat`,
    HOURS_ON_RENT: `Kiralık Saatleri`,
    HSN_SAC_CODE: `HSN/SAC Kod`,
    IGST: `IGST`,
    IMPLEMENTS: `Ekipmanlar`,
    IN_RANGE: `Aralık içerisinde`,
    INCENTIVE: `özendirici`,
    INCENTIVE_PROGRAMS: `Teşvik Programları`,
    INCLUDE_FULLY_COMPLETE: `Tamamlanmış PIP'leri dahil et`,
    INDICATES_REQUIRED_FIELD: `Gerekli alanı gösterir`,
    INFO_MESSAGE_TITLE: `Bir sistem bildirimi gönderildi:`,
    INFO_MESSAGES: `Bilgi Mesajları`,
    INFO_MESSAGES_TITLE: `Birden fazla sistem bildirimi gönderildi:`,
    INFO_REQUEST_STATUS_ERROR: `Bilgi istek ile gönderilmeye hazırdır.`,
    INFORMATION: `Bilgi`,
    INFORMATION_REQUEST: `Bilgi İsteği`,
    INFORMATION_REQUEST_STATUS: `Bilgi İsteği Durumu`,
    INPUT_PIN: `Giriş PIN'i`,
    INSPECTION: `İnceleme`,
    INSTALLED_BY: `Kurulumu Yapan`,
    INSTALLED_BY_IS_REQUIRED: `Kuran Kişi gereklidir`,
    INTERNAL_DEERE_COMMENTS: `Deere Yorumları (dahili)`,
    INTERNAL_EQUIPMENT_NOTES: `Dahili Ekipman Notları`,
    INTERVAL_BEGINS: `Aralık Başlangıcı`,
    INTERVAL_ENDS: `Aralık Bitişi`,
    INTERVAL_TYPE_DESCRIPTION: `Aralık Türü Açıklaması`,
    INVOICE_ACCOUNT: `Fatura Hesabı`,
    INVOICE_DEALER: `Faturalayan Bayi`,
    INVOICE_NUMBER: `Fatura Numarası`,
    INVOICE_REQUEST: `Fatura İsteği`,
    INVOICE_SENT: `Fatura Gönderildi`,
    INVOICE_UPDATED_SUCCESSFULLY: `Fatura Başarıyla Güncellendi`,
    INVOICED: `Faturalı`,
    INVOICED_TO: `Fatura alıcısı`,
    IRC_PIN_MESSAGE: `Müşteri bir IRC'dir ve ilk 500 saat veya 12 aylık makine mülkiyeti için ücretsiz Seyahat Süresi ve Mesafe bilgilerini almaya yetkilidir.`,
    ISSUED: `Yayın Tarihi`,
    ITALIAN: `İtalyanca`,
    ITEM: `Öğeleri`,
    ITEM_NUMBER: `Kalem Numarası`,
    ITEM_NUMBER_IS_REQUIRED: `Öğe Numarası gereklidir`,
    JDLINK_EXPIRES: `JDLink Süre Sonu`,
    JDP_COMMENTS: `JDP Yorumları`,
    JDP_COMMENTS_IS_REQUIRED: `JDP Yorumları gereklidir`,
    JDP_CUSTOMER_RESOLUTION: `JDP Müşteri Çözümü`,
    JDP_CUSTOMER_RESOLUTION_IS_REQUIRED: `JDP Müşteri Çözümü gereklidir`,
    JDP_REASON: `JDP Nedeni`,
    JDP_REASON_IS_REQUIRED: `JDP Nedeni gereklidir`,
    LABOR: `İşçilik`,
    LABOR_ADDITIVE: `İşçilik İlavesi`,
    LABOR_ADDITIVE_COMPLETION_DETAIL: `İşçilik İlavesi Tamamlama Detayı`,
    LABOR_ADDITIVE_PIPS: `İşçilik İlavesi PIP'leri`,
    LABOR_ADDITIVE_TAB: `İşçilik İlavesi ({count})`,
    LABOR_ADJUSTMENT: `İşçilik Ayarı`,
    LABOR_COMMENTS: `İşçilik Yorumlar`,
    LABOR_HOURS: `İşçilik Saati`,
    LABOR_ITEM_DETAILS: `İş Gücü - {quantity} {unit} {description}`,
    LABOR_RATE_APPROVED_SUCCESSFULLY: `İşçilik Ücreti Başarıyla Onaylandı`,
    LABOR_RATE_CHANGE_SUBMITTED: `İşçilik Ücreti Değişikliği Gönderildi`,
    LABOR_RATE_CHANGES_WITH_COUNT: `İşçilik Ücreti Değişiklikleri ({count})`,
    LABOR_RATE_CONFIRM: `İstenen ücret, geçerli ücretten daha düşük.  İsteği göndermek istediğinizden emin misiniz?`,
    LABOR_RATE_DIFFERENCE_LARGE_INFORMATION_MESSAGE: `Kırmızı metindeki oranlar, mevcut hızdan %10'dan fazla bir artış olduğunu gösterir`,
    LABOR_RATE_HISTORY: `İşçilik Ücreti Geçmişi`,
    LABOR_RATE_REJECTED_SUCCESSFULLY: `İşçilik Ücreti Başarıyla Reddedildi`,
    LABOR_RATE_REQUESTS_STATUS: `İşçilik Oranı İstekleri Durumu`,
    LABOR_RATE_RETURNED_SUCCESSFULLY: `İşçilik Ücreti Başarıyla İade Edildi`,
    LABOR_RATES: `İşçilik Ücretleri`,
    LABOR_STATS: `İşçilik İstatistikleri`,
    LABOR_TOTAL: `İşçilik Toplamı`,
    LABOR_TYPE: `İşçilik Türü`,
    LABOR_VALUE: `İşçilik Değeri`,
    LABOR_WITH_COUNT: `İşçilik ({count})`,
    LANGUAGE: `Dil`,
    LAST_LOCATION_FROM: `Son Konum`,
    LAST_NAME: `Soyadı`,
    LAST_NAME_IS_REQUIRED: `Soyadı gereklidir`,
    LAST_PERSONAL_CONTACT: `Son Kişisel İlişki`,
    LAST_SEEN: `Son Görülen`,
    LAST_SEEN_AT_RESPONSIBLE_ACCOUNT: `Sorumlu Hesapta En Son Görülen`,
    LATEST: `En Son`,
    LAW_ENFORCEMENT_AGENCY_DETAILS: `Emniyet Teşkilatı Detayları`,
    LAYOUT_CREATED_SUCCESSFULLY: `Mizanpaj başarıyla oluşturuldu`,
    LAYOUT_DELETED_SUCCESSFULLY: `Mizanpaj başarıyla silindi`,
    LAYOUT_NAME: `Mizanpaj isim`,
    LAYOUT_UPDATED_SUCCESSFULLY: `Mizanpaj başarıyla güncellendi`,
    LEAD_ACCOUNT: `Öncü Hesap`,
    LEAD_DEALER: `Lider Bayi`,
    LESS_THAN: `Daha az`,
    LESS_THAN_OR_EQUALS: `Daha az veya eşitlik`,
    LICENSE_PLATE_NUMBER: `Plaka Numarası`,
    LIFETIME: `Ömür Boyu`,
    LINE_ITEMS_EXPORT: `Satır Öğeleri İhracat`,
    LIST: `Liste`,
    LIST_TOTAL: `Toplam Liste`,
    LOCATION: `Yer`,
    LOCATION_DUE: `Konum Vade Tarihi`,
    LOCATIONS: `Konumlar`,
    LOCATIONS_WITH_COUNT: `Konum ({count})`,
    MACHINE_ALREADY_REGISTERED_TO_THIS_CUSTOMER: `Makine zaten bu müşteriye kaydedilmiş`,
    MACHINE_INFORMATION: `Makine Bilgileri`,
    MACHINE_MODEL_TYPE: `Makine Modeli/Tipi`,
    MACHINE_MODEL_TYPE_REQUIRED: `Makine Modeli/Tipi Gerekli`,
    MACHINE_STATUS: `Makine Durumu`,
    MACHINE_STATUS_UPDATE: `Makine Durumu Güncellemesi`,
    MACHINE_STATUS_UPDATE_ACCEPTED: `Makine Durumu Güncellemesi Kabul Edildi`,
    MACHINE_STATUS_UPDATE_DOCUMENT: `Makine Durumu Güncelleme Belgesi`,
    MACHINE_STATUS_UPDATE_REJECTED: `Makine Durumu Güncellemesi Reddedildi`,
    MACHINE_STATUS_UPDATES_WITH_COUNT: `Makine Durumu Güncellemeleri ({count})`,
    MACHINE_TYPE: `Makine Türü`,
    MACHINE_TYPE_IS_REQUIRED: `Makine Türü gereklidir`,
    MACHINE_USE: `Makine Kullanımı`,
    MAILING_RECIPIENT: `Posta Alıcısı (Ad ve Soyadı)`,
    MAILING_RECIPIENT_REQUIRED: `Posta Alıcısı Gerekli`,
    MAINTENANCE: `Bakım`,
    MAINTENANCE_PLAN: `Bakım Planları`,
    MAINTENANCE_PLAN_INFO: `Bakım Planı Bilgileri`,
    MARK_AS_INPROCESS: `İşlendiği Gibi İşaretle`,
    MARK_AS_REVIEW: `Gözden Geçirildi Olarak İşaretle`,
    MARKETING_INCENTIVE: `Pazarlama - özendirici`,
    MARKETING_JD_PROMISE: `Pazarlama - JD Taahhüdü`,
    MARKETING_MAINTENANCE_PLAN: `Pazarlama - Bakım Planı`,
    MARKETING_MASS_CHANNEL_FOLLOWUP: `Pazarlama - Toplu Kanal Takibi`,
    MARKETING_MASS_CHANNEL_PDI: `Pazarlama - Toplu Kanal PDI'sı`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP: `Toplu Kanal Müşterisi Takibi`,
    MASS_CHANNEL_CUSTOMER_FOLLOW_UP_HELP_TEXT: `Hatırlatıcı, lütfen Satış Arama Programı Sonrası Takibinizi uygulamadan önce eyaletinizdeki ve federal düzeydeki uygun #Arama Yapma# prosedürlerini belirlemek için kendi yasal danışmanınız ile iletişime geçtiğinizden emin olun`,
    MASS_CHANNEL_PDI_CLAIM: `Toplu Kanal PDI'sı`,
    MASTER_WARRANTY_TYPE: `Ana Garanti Türü`,
    MATERIAL: `Malzeme Numarası`,
    MERCHANDISE: `Ticari Ürün`,
    MESSAGE: `Mesaj`,
    MESSAGES: `Mesajlar`,
    METHOD_OF_CONTACT: `İrtibat Yöntemi`,
    METHOD_OF_CONTACT_IS_REQUIRED: `İrtibat Yöntemi gereklidir`,
    METRIC: `Metrik`,
    METRICS: `Ölçümler`,
    MILEAGE_LIMIT: `Dönem Sınırı`,
    MOBILE_PHONE: `Cep Telefonu`,
    MODEL: `Model`,
    MODEL_NUMBER: `Model Numarası`,
    MODEL_YEAR: `Model Yılı`,
    MODIFIED: `Değiştirildi`,
    MONTH_TO_DATE: `Ay Başından Bugüne Kadar`,
    MORE: `Daha`,
    MULTIPLE: `Birden çok`,
    NAME: `Ad`,
    NET: `Net`,
    NET_AMOUNT: `Net Tutar`,
    NET_AMOUNT_PAID: `Net Tutar Ödendi`,
    NET_TOTAL: `Net toplam`,
    NEW: `YENİ`,
    NEW_ACCOUNT: `Yeni Hesap`,
    NEW_CLAIM: `Yeni iddia`,
    NEW_CLAIM_VALUE: `Yeni Talep Değeri`,
    NEW_CUSTOMER_REQUIRED: `Yeni Müşteri gerekiyor`,
    NEW_DEALER: `Yeni Bayi`,
    NEW_DEALER_DISTANCE: `Yeni Satıcı Uzaklığı`,
    NEW_DEALER_LOCATION: `Yeni Bayi Konumu`,
    NEW_LABOR_RATE: `Yeni İşçilik Ücreti`,
    NEW_REQUEST_ENTER_RATES: `Yeni Talep - Oranları Girin`,
    NEW_STATUS: `Yeni Durum`,
    NEW_TRANSFER: `Yeni Transfer`,
    NEW_TRANSFER_CREATED: `Yeni Transfer Oluşturuldu`,
    NEW_VALUE: `Yeni Değer`,
    NO: `Hayır`,
    NO_ACTIVE_WARRANTY: `Aktif Garanti Yok`,
    NO_AFFECTED_PINS: `Bayilik sorumluluğunuz altında etkilenen hiçbir PIN mevcut değil`,
    NO_AUTHORITY_TO_ACCESS: `JDWS'a erişim yetkiniz yok. Katılımcı kullanıcıları otoriteyi doğrulamak için Profil Yöneticinize (DPA) başvurun ve Deere kullanıcıları bu hatanın bir kopyasıyla Destek birimine başvurun`,
    NO_CLAIMS: `Hiçbir talep yok.`,
    NO_CUSTOMER_ASSOCIATED: `İlişkilendirilmiş Müşteri Yok`,
    NO_CUSTOMER_SELECTED: `Hiçbir Müşteri Seçilmedi`,
    NO_DEALER_INVOICES: `Bayi Faturası Yok`,
    NO_DEALERS_MAPPED: `Kullanıcı Kimliğine eşlenmiş hiçbir bayiniz yoktur. Lütfen sistem yöneticiniz ile iletişime geçin.`,
    NO_IF_NO_A_PICTURE_MUST_BE_PROVIDED_AS_EVIDENCE: `Hasar fotoğrafı gerekli değil, lütfen talebe ekleyin.`,
    NO_INFORMATION_AVAILABLE_FOR_THIS_PRODUCT: `Bu Ürün icin herhangi bir bilgi bulunmamaktadır`,
    NO_LABOR_COVERAGE: `İşçilik Kapsamı Yok`,
    NO_LOWERCASE: `Yok`,
    NO_MATCHING_DEALERS: `Filtre metni ile eşleşen hiçbir bayi yok.`,
    NO_OPEN_PART_REQUESTS: `Parça İsteği Yok`,
    NO_OPEN_PIPS: `Açık PIP Yok`,
    NO_PARTS_RETURNED: `Hiçbir Parça İade Edilmedi`,
    NO_PIP_PRODUCTS: `Hiçbir PIP ürünü mevcut değil.`,
    NO_PRODUCT_FOUND: `Hiçbir Ürün Bulunamadı`,
    NO_REQUIRED_ITEMS: `Gereken öğe yok.`,
    NO_RESULTS: `Sonuç Yok`,
    NO_RESULTS_FOUND: `Hiçbir Sonuç Bulunamadı`,
    NO_ROWS_TO_SHOW: `Gostermek icin satir yok`,
    NO_SPECIAL_INSTRUCTIONS: `Özel talimat yok.`,
    NO_TRAVEL: `Yolçuluk Yok`,
    NON_RECOVERABLE_TAXES: `Geri Döndürülemez Vergiler`,
    NON_TRACKED_PINS_HELP_TEXT: `Kayıt sonrasına kadar bazı ürünler Garanti'de görünmüyor. Aramanız, bu ürünler aralığı ile eşleşiyor.`,
    NON_TRAVEL: `Seyahat Dışı`,
    NONE: `Yok`,
    NORMAL: `NORMAL`,
    NOT_EQUAL: `eşit değildir`,
    NOTIFICATION_ADDED_SUCCESSFULLY:`Bildirim başarıyla eklendi`,
    NOTIFICATION_DELETED_SUCCESSFULLY:`Bildirim Başarıyla Silindi`,
    NOTIFICATION_SEQUENCE_UPDATED_SUCCESSFULLY: `Bildirim sırası başarıyla güncellendi`,
    NOTIFICATION_UPDATED_SUCCESSFULLY:`Bildirim başarıyla güncellendi`,
    NOTIFICATIONS: `Bildirimler`,
    NUMBER_OF_DIAGNOSTICS_OCCURRENCES: `Ditagnostik Olaylarının Sayısı`,
    NUMBER_OF_OPEN_PIPS: `{number} Açık PIP`,
    NUMBER_OF_REPAIR_OCCURRENCES: `Tamir Olaylarının Sayısı`,
    NUMBER_OF_REPLACEMENT_OCCURRENCES: `Değişiklik Olaylarının Sayısı`,
    OLD_LABOR_RATE: `Eski İşçilik Ücreti`,
    ON_SHELF: `Rafta`,
    ON_SHELF_COST: `Raf Maliyeti`,
    ONE_ITEM_MUST_BE_SELECTED: `Bir öğenin seçilmesi gerekir`,
    OPEN: `Açık`,
    OPEN_PART_REQUESTS: `Açık Parça Talepleri`,
    OPEN_PART_REQUESTS_WITH_COUNT: `Açık Parça Talebi ({count})`,
    OPEN_PIP_COUNT: `PIP Sayısını Aç`,
    OPEN_PIP_PROGRAMS: `PIP Kaydı`,
    OPEN_PIPS: `Tamamlanmamış PIP'ler`,
    OPEN_PIPS_REPORT: `Tamamlanmamış PIP Raporu`,
    OPEN_PIPS_TAB: `Açık PIP'ler ({count})`,
    OPEN_PIPS_Y_N: `Açık PIP'ler (Y/N)`,
    OPERATORS_COMPLAINT: `Operatörün şikayeti neydi?`,
    OPERATORS_COMPLAINT_IS_REQUIRED: `Operatörün şikayeti gereklidir`,
    OPERATORS_MANUAL_NUMBER: `Kullanıcı El Kitabı Numarası`,
    OPTION_CODE: `Seçim Kodu`,
    OPTION_CODE_CREATED_SUCCESSFULLY: `Seçim Kodu Başarıyla Yaradıldı`,
    OPTION_CODE_DELETED_SUCCESSFULLY: `Seçim Kodu Başarıyla Silindi`,
    OPTION_CODES: `Seçenek Kodları`,
    OR: `veya`,
    ORIGINAL_CLAIM_VALUE: `Orijinal Talep Değeri`,
    ORIGINAL_SUBMISSION_DATE: `Orijinal Gönderim Tarihi`,
    ORIGINALLY_SUBMITTED: `Orijinal Olarak Gönderildi`,
    OTHER: `Diğer`,
    OTHER_AMOUNT_OF_USE: `Diğer Kullanım Miktarı`,
    OTHER_AMOUNT_OF_USE_REQUIRED: `Diğer Gerekli Kullanım Miktarı`,
    OTHER_CREDIT: `Diğer Alacak`,
    OTHER_CREDIT_1: `Diğer Alacak 1`,
    OTHER_CREDIT_2: `Diğer Alacak 2`,
    OTHER_CREDIT_3: `Diğer Alacak 3`,
    OTHER_CREDIT_ADJUSTMENT: `Diğer Alacak Ayarı`,
    OTHER_CREDIT_ITEM_DETAILS: `Diğer Alacak - {description} ({quantity} {unit})`,
    OTHER_CREDIT_TOTAL: `Diğer Alacak toplamı`,
    OTHER_CREDITS: `Diğer Alacaklar`,
    OTHER_CREDITS_WITH_COUNT: `Diğer Krediler ({count})`,
    OTHER_INSTRUCTIONS: `Diğer Talimatlar`,
    OUTPUT_PIN: `Çıktı PIN`,
    OVERDUE: `Gecikmiş`,
    OVERRIDE_ACCOUNT: `Hesabı Geçersiz Kıl`,
    OVERRIDE_EFFECTIVE_DATE: `Geçersiz Kılma Etkinlik Tarihi`,
    OVERRIDE_SUGGESTED_ACCOUNT: `Önerilen Hesabı Geçersiz Kıl`,
    OWNERSHIP_STATUS: `Sahiplik Durumu`,
    OWNERSHIP_STATUS_IS_REQUIRED: `Sahiplik Durumu gereklidir`,
    PART: `Parça`,
    PART_1: `Parça 1`,
    PART_2: `Parça 2`,
    PART_3: `Parça 3`,
    PART_4: `Parça 4`,
    PART_5: `Parça 5`,
    PART_6: `Parça 6`,
    PART_7: `Parça 7`,
    PART_8: `Parça 8`,
    PART_9: `Parça 9`,
    PART_10: `Parça 10`,
    PART_AMONT_OF_USE: `Parça Kullanım Miktarı`,
    PART_FAMILY: `Parça Ailesi`,
    PART_ITEM_DETAILS: `Parçalar - {quantity} {description} Parça No {partNumber}`,
    PART_NUMBER: `Parça Numarası`,
    PART_REQUEST: `Parça İsteği`,
    PART_REQUEST_NUMBER: `Parça Talebi {rgaNumber}`,
    PART_REQUEST_STATUS: `Parça Talebi Durumu`,
    PART_REQUESTS: `Parça İstekleri`,
    PART_REQUESTS_SEARCH_BY_CLAIM_PLACEHOLDER: `Kleym Numarasını Gir, Minimum 4 Karakter`,
    PART_REQUESTS_SEARCH_BY_CLAIM_VALIDATION_ERROR: `Kleym aramasının en az 4 karakter olması gerekir`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_ERROR: `DTAC Vaka Numarası aramasının tam DTAC Vaka Numarası olması gerekir, en az 4 karakter`,
    PART_REQUESTS_SEARCH_BY_DTAC_CASE_NUMBER_PLACEHOLDER: `Tam DTAC Vaka Numarasını Gir`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_ERROR: `Parça Numarası aramasının en az 4 karakter olması gerekir`,
    PART_REQUESTS_SEARCH_BY_PART_NUMBER_PLACEHOLDER: `Parça Numarasını Gir, minimum 4 Karakter`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_ERROR: `Parça İstek Numarası aramasının en az 4 karakter olması gerekir`,
    PART_REQUESTS_SEARCH_BY_PART_REQUEST_PLACEHOLDER: `Parça İstek Numarasını Gir, minimum 4 Karakter`,
    PART_REQUESTS_SEARCH_BY_PIN_ERROR: `PIN Aramasının en az 4 karakter olması gerekir`,
    PART_REQUESTS_SEARCH_BY_PIN_PLACEHOLDER: `PIN'i Gir, minimum 4 Karakter`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_ERROR: `İş Emri aramasının tam İş Emri olması gerekir, en az 2 karakter`,
    PART_REQUESTS_SEARCH_BY_WORK_ORDER_PLACEHOLDER: `Tam İş Emrini Gir`,
    PART_REQUESTS_UPDATED_SUCCESSFULLY: `Parça İsteği başarıyla güncellendi`,
    PART_RETURN: `Parça İadesi`,
    PART_RETURNS: `Parça İadeleri`,
    PART_SERIAL_NUMBER: `Parça Seri Numarası`,
    PART_SERIAL_NUMBER_IS_REQUIRED: `Parça Seri Numarası gereklidir`,
    PART_TOTAL: `Parça Toplamı`,
    PART_TYPE: `Parça Türü`,
    PART_USE: `Parça Kullanımı`,
    PART_VALUE: `Parça Değeri`,
    PARTIAL_DEBIT: `Kısmi Borç`,
    PARTICIPANT: `Katılımcı`,
    PARTS: `PARÇALAR`,
    PARTS_ADDITIVE: `Parça İlavesi`,
    PARTS_ADJUSTMENT:`Parça Ayarı`,
    PARTS_COVERAGE_SEARCH: `Parça Kapsamı Araması`,
    PARTS_TEMPLATE: `Parça Şablonu`,
    PARTS_USE: `Parça Kullanım`,
    PARTS_USE_IS_REQUIRED: `Parçaların Kullanımı gereklidir`,
    PARTS_WITH_COUNT: `Parçalar ({count})`,
    PARTS_WITH_PARENTHESES: `Parça(lar)`,
    PAST_DUE: `Süre Sona Erdi`,
    PAYER_ACCOUNT: `Ödeyen Hesabı`,
    PC_LIMIT:`Balya Sınırı`,
    PERCENT_COMPLETE: `Tamamlanan Yüzde`,
    PERCENTAGE: `Yüzde`,
    PERCENTAGE_DEBIT: `Yüzde Borç`,
    PERCENTAGE_SYMBOL: `%{percentage}`,
    PERCENTAGE_TO_DEBIT:`Borç Yüzdesi`,
    PERMANENTLY_OUT_OF_SERVICE_MACHINES_HELP_TEXT: `Servis dışı makineler için, makinenin gelecekteki herhangi bir noktada yeniden oluşturulamayacağını, onarılamayacağını veya kullanılamayacağını doğrulamak üzere makinenin bir resmini ekleyin. Hizmet dışı kalan makineler, PIP'ler için her türlü yeterliliğe sahip değildir.`,
    PERSON_RESPONSIBLE: `Sorumlu Kişi`,
    PHONE: `TELEFON`,
    PHONE_REQUIRED: `Telefon Gerekli`,
    PICTURE: `görüntü`,
    PICTURE_REQUEST: `Resim İsteği`,
    PICTURE_REQUEST_STATUS: `Resim İsteği Durumu`,
    PICTURE_REQUEST_STATUS_ERROR: `Ekler bu istek ile gönderilmeye hazır.`,
    PIN: `PIN`,
    PIN_CREATED_SUCCESSFULLY: `PIN Başarıyla Oluşturuldu`,
    PIN_CROSS_REFERENCE: `PIN Çapraz Referans`,
    PIN_INVALID: `PIN Geçersiz`,
    PIN_IS_REQUIRED: `Pin, gereklidir`,
    PIN_REQUIRED: `PIN Gerekli`,
    PIN_SEARCH: `Aramayı Sabitle`,
    PIN_SEARCH_INFORMATION: `Arama Bilgilerini Sabitle`,
    PIN_TRANSFER_INFORMATION: `Pin Aktarım Bilgileri`,
    PINS: `PIN'ler`,
    PINS_NOT_REGISTERED: `PIN'ler Kayıtlı Değil`,
    PIP: `PIP`,
    PIP_CODE: `PIP Kodu`,
    PIP_CODE_CREATED_SUCCESSFULLY: `PIP kodu isteği başarıyla oluşturuldu`,
    PIP_CODE_REQUEST: `PIP Kodu Talebi`,
    PIP_CODE_REQUEST_APPROVED: `PIP Kodu Talebi Onaylandı`,
    PIP_CODE_REQUEST_REJECTED: `PIP Kodu Talebi Reddedildi`,
    PIP_CODE_REQUESTS_WITH_COUNT: `PIP Kodu Talebi ({count})`,
    PIP_COMPLETION_STATUS: `PIP Tamamlama Durumu`,
    PIP_DETAILS: `PIP Ayrıntıları`,
    PIP_HISTORY: `PIP Geçmişi`,
    PIP_ID: `PIP No`,
    PIP_NUMBER: `PIP Numarası`,
    PIP_PROGRAM: `PIP Programı`,
    PIP_PROGRAM_IS_REQUIRED: `PIP Programı gereklidir`,
    PIP_PROGRAMS: `PIP Programları`,
    PIP_SEARCH: `PIP Araması`,
    PIP_STATUS: `PIP Durumu`,
    PIP_TYPE: `PIP Türü`,
    PIP_TYPES: `PIP Türleri`,
    PIPS: `PIP'ler`,
    PIPS_UNPAID_LABOR_ADDITIVE: `İşçilik İlavesi Ödenmeyen PIP'ler`,
    PLAN_DESCRIPTION: `Plan Açıklaması`,
    PLAN_END_DATE: `Plan Bitiş Tarihi`,
    PLAN_ENDS: `Plan Bitişleri`,
    PLAN_NAME: `Plan Adı`,
    PLAN_NAME_IS_REQUIRED: `Plan Adı Gereklidir`,
    PLAN_NAMES: `Plan Adları`,
    PLAN_START_DATE: `Plan Başlangıç Tarihi`,
    PLAN_STARTS: `Plan Başlangıçları`,
    PLANNED_BY: `Tarafından Planlanan`,
    PLANT: `Tesis`,
    PLATE_REQUEST_INFORMATION: `Plaka İsteği Bilgileri`,
    PLEASE_SELECT_A_LEAD_ACCOUNT: `Lütfen birincil bir hesap seçin`,
    PLEASE_SELECT_CLAIM_TYPE: `Lütfen talep türünü seçin`,
    POLISH: `Lehçe`,
    PORTUGUESE: `Portekizce`,
    POSTAGE_DELIVERY_DATE: `Posta Teslim Tarihi`,
    POSTAL_CODE: `Posta Kodu`,
    POSTAL_CODE_REQUIRED: `Posta Kodu Gerekli`,
    POSTAL_TRACKING_NUMBER: `Posta Takip Numarası`,
    POTENTIAL_RESPONSIBLE_DEALER: `Olası Sorumlu Satıcı`,
    PRE_DELIVERY_INSPECTION: `Teslimat Öncesi İnceleme`,
    PREFERRED_THEME: `Tercih Edilen Tema`,
    PREPARE_AUDIT: `Denetim Hazırla`,
    PREPARED: `Hazır`,
    PREPARING_AUDIT_FOR_WITH_DEALER: `{dealer} İçin Denetim Hazırlama`,
    PREVIOUS_AMOUNT_OF_USE: `Önceki Kullanım Miktarı`,
    PREVIOUS_INVOICE_NUMBER: `Önceki Fatura Numarası`,
    PREVIOUS_INVOICE_NUMBER_IS_REQUIRED: `Önceki Fatura Numarası gereklidir`,
    PREVIOUS_MONTH: `Önceki Ay`,
    PRICE: `Fiyat`,
    PRICING_SUMMARY: `Fiyatlandırma Özeti`,
    PRIMARY_ACTION: `Birincil İşlem`,
    PRIMARY_LANGUAGE: `Birincil Dil`,
    PRINT: `Yazdır`,
    PRINT_CLAIM: `Kleymi Yazdır`,
    PRINT_REGISTRATION_FORM: `Baski Kayıt Formu`,
    PRINT_REGISTRATION_FORM_MESSAGE: `Ürünün ilk sahibi üzerine kayıtlı. şimdi kayıt formunu yazdırmak istiyorsunuz?`,
    PRINT_TO_PDF: `PDF Yazdır`,
    PRIORITY: `Öncelik`,
    PRNT_CLM: `Iddianı  Görüntüle`,
    PROCESS_DATE: `İşlem Tarihi`,
    PROCESSED: `İşlendi`,
    PROCESSED_PART_REQUESTS: `İşlenmiş Parça İstekleri`,
    PROCESSING_STATUS: `İşlem Durumu`,
    PROCESSING_STATUS_DESCRIPTION: `İşlem Durumu Açıklaması`,
    PRODUCT_DETAILS: `Ürün Ayrıntıları`,
    PRODUCT_HIERARCHY: `Ürün Hiyerarşi`,
    PRODUCT_INFORMATION: `Ürün Bilgisi`,
    PRODUCT_REGISTERED: `Ürün Kayıtlı`,
    PRODUCT_REGISTRATION: `Ürün Kaydı`,
    PRODUCT_REGISTRATION_PENDED: `Ürün Kaydı Beklemede`,
    PRODUCT_TRACKING: `Ürün İzleme`,
    PRODUCTS: `Ürünler`,
    PRODUCTS_BY_CUSTOMER: `Müşterilere Göre Ürünleri`,
    PRODUCTS_BY_CUSTOMER_PARTIAL_DATA_WARNING: `Geçici bir sistem bağlantısı sorunu nedeniyle geçmiş PIN'ler arama sonuçlarında eksik olabilir`,
    PRODUCTS_WITH_COUNT: `Ürünler ({count})`,
    PROGRAM: `Program`,
    PROGRAM_DESCRIPTION: `Program Açıklaması`,
    PROGRAM_IS_REQUIRED: `Program adı gerekli.`,
    PROGRAM_NAME: `Program Adı`,
    PROGRAM_NAME_IS_REQUIRED: `Program adı gerekli.`,
    PROGRAM_NUMBER: `Program Sayısı`,
    PRT: `PRT`,
    PRTS: `PRT'ler`,
    PURCHASE_INFO: `Satın Alma Bilgileri`,
    PURCHASE_ORDER: `Satınalma Siparişi`,
    PURCHASE_ORDER_IS_REQUIRED: `Satınalma Siparişi gereklidir`,
    PURCHASER_TYPE: `Alıcı Türü`,
    PURCHASER_TYPE_REQUIRED: `Gereken Alıcı Türü`,
    PUSH_XML: `XML'yi yeniden gönder`,
    QTY: `Mkt.`,
    QUALIFY_FOR_EMISSIONS: `Emisyon için Yeterlilik Onayı Verin`,
    QUANTITY: `Miktar`,
    QUANTITY_1: `Miktar 1`,
    QUANTITY_2: `Miktar 2`,
    QUANTITY_3: `Miktar 3`,
    QUANTITY_4: `Miktar 4`,
    QUANTITY_5: `Miktar 5`,
    QUANTITY_6: `Miktar 6`,
    QUANTITY_7: `Miktar 7`,
    QUANTITY_8: `Miktar 8`,
    QUANTITY_9: `Miktar 9`,
    QUANTITY_10: `Miktar 10`,
    QUERY_MUST_CONTAIN_3_CHARACTERS: `Sorgunun en az 3 karakter içermesi gerekir`,
    QUEST_DESC: `Sorgulanabilir Açıklama`,
    QUESTIONABLE_PART: `Sorgulanabilir Parça`,
    QUEUED: `Sıraya Alındı`,
    READING_DATE: `Okuma Tarihi`,
    REASON: `Neden`,
    REASON_EVENT_NUMBER: `Neden Olay Numarası`,
    REASON_FOR_CHANGE: `Değişiklik Nedeni`,
    REASON_FOR_DEBIT: `Borç Gerekçesi`,
    REASON_FOR_MISSING_PLATE: `Eksik Plakanın Nedeni`,
    REASON_FOR_MISSING_PLATE_REQUIRED: `Eksik Plakanın Nedeni Gerekli`,
    REASON_FOR_OVERRIDE: `Geçersiz Kılma Nedeni`,
    REASON_FOR_REFUSAL: `Ret Nedeni`,
    REASON_FOR_RETURN: `İade Nedeni`,
    REASON_FOR_RETURN_IS_REQUIRED: `İade Nedeni gereklidir`,
    REASON_FOR_TRANSFER: `Transfer Nedeni`,
    REASON_FOR_TRANSFER_MUST_CONTAIN_ALPHANUMERIC_CHARACTERS: `Transfer Nedeni'nin alfasayısal karakterler içermesi gerekir`,
    REASON_FOR_TRANSFER_REJECTION: `Transfer Reddetme Nedeni`,
    RECIPIENT_DEALER_OR_TCSM: `Alıcı(Bayi veya TCSM)`,
    RECIPIENT_MAILING: `Posta Alıcısı`,
    RECOMMENDATION: `Öneri`,
    RECOMMENDATION_DATE: `Öneri Tarihi`,
    RECOMMENDED_ACCOUNT: `Önerilen Hesap`,
    RECONCILE: `Karşılaştır`,
    RECONCILE_CLAIM: `Talebi Karşılaştır`,
    RECONCILED: `MUTABAKAT`,
    RECORD_AUDIT: `Denetimi Kaydet`,
    RECORD_AUDIT_FOR: `{dealer} İçin Denetimi Kaydet`,
    RECORDS_FOUND: `{countToDisplay} kayıt bulundu`,
    RECOVERABLE_TAXES: `Döndürülebilir vergiler`,
    RECOVERED: `Kurtarıldı`,
    RECOVERED_WITH_MISSED_ADDITIVES: `Eksik İlavelerle Kurtarıldı`,
    RECOVERED_WITHOUT_ADDITIVES: `İlaveler Olmadan Kurtarıldı`,
    RECOVERY: `Kurtarma`,
    RED_MUST_BE_LESS_THAN_YELLOW: `Kırmızı Gösterge Değerinin Sarı Gösterge Değerinden Düşük Olması Gerekir`,
    REFERENCE_1: `Referans 1`,
    REFERENCE_2: `Referans 2`,
    REFERENCE_INFORMATION: `Referans Bilgileri`,
    REFERENCE_NUMBER1: `Referans Numarası 1`,
    REFERENCE_NUMBER2: `Referans Numarası 2`,
    REGION: `Bölge`,
    REGISTER: `Kaydet`,
    REGISTER_A_PRODUCT_BY_PIN: `Ürünü, PIN'e göre kaydedin`,
    REGISTER_A_PRODUCT_TO_ADD: `Garanti sistemine eklemek icin Ürünü  kaydet`,
    REGISTER_ANOTHER_PRODUCT: `Başka Bir Ürün Kaydedin`,
    REGISTER_PRODUCT: `Ürün Kaydını Yap`,
    REGISTER_PRODUCT_AND_REGISTER_ANOTHER: `Garanti sistemine eklemek icin Ürünü kaydet`,
    REGISTERED: `Kaydedildi`,
    REGISTRATION: `Kayıt`,
    REGISTRATION_DATE: `Kayıt Tarihi`,
    REGISTRATION_DATES: `Kayıt Tarihleri`,
    REGISTRATION_FORM: `Kayıt Formu`,
    REGISTRATION_HISTORY: `Kayıt Geçmişi`,
    REGISTRATION_NOT_ALLOWED: `Bu ürün için kayda izin verilmiyor`,
    REGISTRATION_REVIEW: `Kayıt İnceleme`,
    REGISTRATION_REVIEW_TAB: `Kayıt İnceleme ({count})`,
    REGISTRATION_STATUS: `Kayıt Durumu`,
    REGISTRATION_STATUS_CANNOT_BE_NEW: `Kayıt Durumu, Yeni olamaz`,
    REGISTRATION_STATUS_REQUIRED: `Kayıt Durumu gereklidir`,
    REGISTRATION_SUCCESS: `Kayıt Başarılı`,
    REGISTRATION_TYPE: `Kayıt Türü`,
    REGISTRATION_TYPE_CANNOT_BE_NEW: `Kayıt Türü, Yeni olamaz`,
    REGISTRATION_TYPE_REQUIRED: `Gereken Kayıt Türü`,
    REGISTRATION_UPDATED_SUCCESSFULLY: `Kayıt başarıyla Güncelleştirildi`,
    REGISTRATIONS_REVIEW: `Kayıtları İnceleme`,
    REIMBURSED: `Geri Ödendi`,
    REIMBURSED_AMOUNT: `Geri Ödenen Tutar`,
    REIMBURSED_PERCENTAGE: `Geri Ödenen Yüzde`,
    REIMBURSED_PERCENTAGE_INDICATOR: `Geri Ödenen Yüzde Göstergesi`,
    REIMBURSEMENT_DETAILS: `Geri Ödeme Detayları`,
    REIMBURSEMENT_PERCENTAGE: `Geri Ödeme Yüzdesi`,
    REIMBURSEMENT_SUMMARY: `Geri Ödeme Özeti`,
    REJECT: `Reddet`,
    REJECT_LABOR_RATE: `İşçilik Ücretini Reddet`,
    REJECT_SPECIAL_ALLOWANCE_CLAIM: `Özel Ödenek Kelymini Reddet`,
    REJECTED: `REDDEDİLDİ`,
    REJECTED_APPEAL: `REDDEDİLEN BAŞVURU`,
    RELATIONSHIP: `İlişki`,
    RELATIONSHIP_IS_REQUIRED: `İlişki gereklidir`,
    REMOVE_FILTER: `Filtreyi Kaldır`,
    REMOVE_FROM_AUDIT: `Denetimden Kaldır`,
    REMOVE_LAYOUT: `Mizanpaj Kaldır`,
    RENTAL_PINS: `Kiralama PIN'leri`,
    REPAIR_DATE: `Onarım Tarihi`,
    REPAIR_DATE_CANNOT_BE_BEFORE_FAILURE_DATE: `Onarım tarihi, başarısızlık tarihinden önce olamaz`,
    REPAIR_NUMBER: `Onarım Numarası`,
    REPAIR_NUMBER_IS_REQUIRED: `Tamir Numarası gereklidir`,
    REPAIR_REPLACE_INDICATOR: `Onar/Değiştir Göstergesi`,
    REPAIRED: `Onarıldı`,
    REPAIRED_DATE: `Tamir Edildiği Tarih`,
    REPAIRED_DATE_CANNOT_BE_BEFORE_FAILED_DATE: `Tamir edildiği tarih, başarısız tarihinden önce olamaz`,
    REPAIRED_DATE_IS_REQUIRED: `Tamir Edildiği Tarih gereklidir`,
    REPORT_DATE: `Rapor Tarihi`,
    REPORT_NUMBER: `Rapor Numarası`,
    REPORTS: `Raporlar`,
    REQ_ADDL: `Alacağı Düzelt`,
    REQUEST: `İstek`,
    REQUEST_DATE: `Talep tarihi`,
    REQUEST_DETAILS: `İstek Detayları`,
    REQUEST_DUPLICATE_PIN_PLATE: `Yinelenen PIN Plakası İste`,
    REQUEST_FORM: `Talep Formu`,
    REQUEST_PIP_CODE: `İstek PIP Kodu`,
    REQUEST_STATUS: `Istek durumu`,
    REQUEST_SUBMITTED: `Talep Gönderildi`,
    REQUEST_TYPE: `İstek Türü`,
    REQUEST_UPDATED_SUCCESSFULLY: `Başarıyla Güncellendi Talep Edildi`,
    REQUEST_WARRANTY_CLAIM_DEBIT: `Garanti Kleymli Borç Talep Et`,
    REQUESTED: `İstendi`,
    REQUESTED_BY: `Talep Eden`,
    REQUESTED_DATE: `Talep tarihi`,
    REQUESTED_DATES: `Talep Tarihleri`,
    REQUESTED_DIAGNOSTIC_AMOUNT: `Talep Edilen Teşhis Miktarı`,
    REQUESTED_DIAGNOSTIC_HOURS: `Talep Edilen Teşhis Saatleri`,
    REQUESTED_LABOR_AMOUNT: `Talep Edilen İşçilik Miktarı`,
    REQUESTED_LABOR_HOURS: `Talep Edilen İşçilik Saati`,
    REQUESTED_OTHER_CREDITS: `İstenen Diğer Alacaklar`,
    REQUESTED_PARTS: `İstenen Parçalar`,
    REQUESTED_REPAIR_AMOUNT: `Talep Edilen Onarım Tutarı`,
    REQUESTED_REPAIR_HOURS: `Talep Edilen Onarım Saatleri`,
    REQUESTED_TRAVEL_TOTAL: `Talep Edilen Seyahat Toplamı`,
    REQUESTER_TCSM: `Talep sahibi (TCSM)`,
    REQUESTER_TCSM_REQUIRED: `Talep Edilen (TCSM)`,
    REQUIRED: `gereklidir`,
    REQUIRED_CRITERIA: `Gerekli Kriterler`,
    REQUIRED_ITEMS: `Gerekli Öğeler`,
    RESEND_XML: `XML'yi yeniden gönder`,
    RESET: `Sıfırla`,
    RESPONDENT_INFORMATION: `Yanıt Veren Bilgileri`,
    RESPONSIBILITY_OF: `Sorumluluk`,
    RESPONSIBLE_ACCOUNT: `Sorumlu Hesap`,
    RESPONSIBLE_ACCOUNT_IS_REQUIRED: `Sorumlu hesap gereklidir`,
    RESPONSIBLE_DEALER: `Sorumlu Bayi`,
    RESPONSIBLE_DEALER_REPORT_RECORDS_COUNT_WARNING: `İlk 100 sonuç gösteriliyor. Tam sonuçlar için indirin`,
    RET: `İade`,
    RETAIL_INSTALL: `Perakende/Kurulum`,
    RETAIL_INSTALL_DATE: `Perakende/Kurulum Tarihi`,
    RETAIL_INSTALL_IS_REQUIRED: `Perakende/Kurulum gereklidir`,
    RETAILER_NAME: `Perakendeci Adı`,
    RETAILER_NAME_IS_REQUIRED: `Perakendeci Adı gereklidir`,
    RETRY: `yeniden deneyin`,
    RETURN: `Geri Çevir`,
    RETURN_LABOR_RATE: `İşçilik İadesi`,
    RETURN_REQUEST: `İade İsteği`,
    RETURN_SPECIAL_ALLOWANCE_CLAIM: `Özel Ödenek Kleymini Geri Çevir`,
    RETURN_STATUS: `İade Durumu`,
    RETURNED: `İADE EDİLDİ`,
    RETURNED_DATE_CANNOT_BE_BEFORE_DELIVERED_DATE: `İade edildiği tarih, teslim edildiği tarihten önce olamaz`,
    RETURNED_DATE_IS_REQUIRED: `İade edildiği tarih gereklidir`,
    RETURNED_MACHINE_STATUS_UPDATE: `İade Edilen Makine Durumu Güncellemesi`,
    REVIEW_DEALER_RECOMMENDATIONS: `İnceleme için PIN'leri işaretlemek istediğinizden emin misiniz?`,
    REVISE: `Revize Et`,
    REVISED: `REVİZE EDİLDİ`,
    ROLLING_12_CREDIT_AMOUNT: `Toplam 12 Kredi Tutarı`,
    ROLLING_12_MONTHS: `12 Ay Boyunca`,
    RUN_REPORT: `Raporu Çalıştır`,
    RUSSIAN: `Rusça`,
    SAP_DOWN_WARNING: `Garanti Sistemi işlevselliği eksik. Bunu mümkün olduğu kadar çabuk düzeltmek için çalışıyoruz. Sistem kullanılabilirliğini kontrol etmek için tarayıcıyı yenileyin.`,
    SAVE: `Kaydet`,
    SAVE_AS_DRAFT: `Taslak Olarak Kaydet`,
    SAVE_AS_NEW_LAYOUT: `Yeni kaydet mizanpaj`,
    SAVE_AUDIT: `Denetimi Kaydet`,
    SAVE_CHANGES: `Değişiklikleri Kaydet`,
    SAVE_TO_VALIDATE: `Doğrulamak için Kaydet`,
    SAVE_VALD: `Kaydet ve Doğrula`,
    SAVE_VALIDATE: `Kaydet ve Doğrula`,
    SEARCH: `Ara`,
    SEARCH_BOX_PLACEHOLDER: `PIN, Seri No, Kleym No, DTAC Olayı veya Müşteri Adı'nı girin`,
    SEARCH_BY_CLAIM_TYPE: `Tam talep türünü girin`,
    SEARCH_BY_CLAIM_TYPE_VALIDATION_FAIL: `Kleym aramasının, tam talep türüne uygun olması gerekir, 4 ila 9 karakter`,
    SEARCH_BY_FAILURE_PART_NUMBER: `Tam arızalı parça numarasını girin`,
    SEARCH_BY_FAILURE_PART_NUMBER_VALIDATION_FAIL: `Talep aramasının, tam arızalı parça numarasına uygun olması gerekir, minimum 4 karakter.`,
    SEARCH_BY_WORK_ORDER: `İş Emrini Gir, minimum 2 karakter`,
    SEARCH_BY_WORK_ORDER_VALIDATION_FAIL: `İş Emri aramasının minimum 2 karakter arasında olması gerekir`,
    SEARCH_PRODUCT_BY_CLAIM_PLACEHOLDER: `Tam Kleym numarasını girin`,
    SEARCH_PRODUCT_BY_CLAIM_VALIDATION_FAIL: `Kleym aramasının, 4 ila 9 karakterden oluşan tam talep numarası ile olması gerekir`,
    SEARCH_PRODUCT_BY_COMPONENT_PLACEHOLDER: `Tam Bileşen seri numarasını girin`,
    SEARCH_PRODUCT_BY_COMPONENT_VALIDATION_FAIL: `Bileşen aramasının en az 1 karakterli tam seri numarası ile yapılması gerekir`,
    SEARCH_PRODUCT_BY_FULL_PIN_PLACEHOLDER: `PIN girin`,
    SEARCH_PRODUCT_BY_MODEL_PLACEHOLDER: `Tam Model numarasını girin`,
    SEARCH_PRODUCT_BY_MODEL_VALIDATION_FAIL: `Model aramasının, 3 ila 12 karakterden oluşan tam model numarası ile olması gerekir`,
    SEARCH_PRODUCT_BY_PIN_PLACEHOLDER: `PIN'i Gir, minimum 6 karakter`,
    SEARCH_PRODUCT_BY_PIN_VALIDATION_FAIL: `PIN aramasının 6 ila 17 karakter arasında olması gerekir`,
    SEARCH_PRODUCT_BY_PIP_PLACEHOLDER: `Minimum 4 karakterdeki PIP Numarası'nı girin`,
    SEARCH_PRODUCT_BY_PIP_VALIDATION_FAIL: `PIP aramasını 4 ila 12 karakterden oluşmalıdır`,
    SEARCH_RESULTS_TAB: `Arama Sonuçları ({count})`,
    SECOND_SHIP_TO_LOCATION: `İkinci Sevk Yeri Konumu`,
    SELECT: `Seç`,
    SELECT_A_RANGE: `Bir aralık seçin`,
    SELECT_ALL: `Tümünü Seç`,
    SELECT_AUTO_SUBMIT: `Otomatik Gönder'i Seç`,
    SELECT_BRANCH: `Şubeyi Seç`,
    SELECT_CLAIM_TYPE: `Kleym Türünü Seç`,
    SELECT_COLUMNS: `Sütunları Seç`,
    SELECT_COUNTRY: `Ülkeyi Seç`,
    SELECT_CSV_SEPARATOR: `CSV Ayırıcı seçin`,
    SELECT_DATE_FORMAT: `Tarih Formatını Seç`,
    SELECT_DEALERS_AND_STATUS: `Bayileri ve Durumu Seç`,
    SELECT_DECIMAL_FORMAT: `Ondalık Formatı Seç`,
    SELECT_DISPLAY_FORMAT: `Ekran Formatını Seç`,
    SELECT_FACTORY: `Fabrikayı Seç`,
    SELECT_LANGUAGE: `Dili Seç`,
    SELECT_LAYOUT: `Mizanpaj Seç`,
    SELECT_PIP_CODE: `PIP Kodu Seç`,
    SELECT_PLAN_NAMES: `Plan Adlarını Seç`,
    SELECT_SERVICE_INTERVAL_TYPES: `Servis Aralığı Türlerini Seç`,
    SELECT_SORT_BY: `Göre Sırala Seç`,
    SELECT_SORT_DIRECTION: `Sıralama Yönü Seç`,
    SELECT_STATE: `Durumu Seç`,
    SELECT_STATUS: `Durum Seç`,
    SELECT_TERRITORY: `Bölge Seç`,
    SELECT_THEME: `Temayı Seç`,
    SELECT_TIME_ZONE: `Zaman Dilimini Seç`,
    SELECT_VALUES_TO_APPROVE: `Onaylanacak Değerleri Seç`,
    SELECTED_COLUMNS: `Sütunları Seçilmiş`,
    SELECTED_FOR_AUDIT: `Denetim için Seçildi`,
    SELECTED_FOR_AUDIT_VSR: `Bu talep için gerekli denetim belgelerini ve ataşmanları için DTAC Çözümü 221475'e bakın`,
    SELECTING_MULTIPLE_ACCOUNTS_AND_WARRANTY_TYPES_IMPACTS_PERFORMANCE: `Birden fazla Hesap ve Garanti Türü seçmek, performansı etkiler`,
    SEND: `Gönder`,
    SERIAL_NUMBER: `Seri numarası`,
    SERIAL_NUMBER_INVOICE_NUMBER: `Seri numarası / Fatura numarası`,
    SERVER_TOOK_TOO_LONG_TO_REPLY: `Sunucunun yanıt vermesi çok uzun zaman aldı ve istek iptal edildi. Lütfen daha belirgin bir istek deneyin ya da daha sonra tekrar deneyin.`,
    SERVICE_DATE_IS_REQUIRED: `Servis Tarihi Gerekiyor`,
    SERVICE_INTERVAL: `Servis Aralığı`,
    SERVICE_INTERVAL_BEGIN_DATE: `Servis Aralığı Başlangıç Tarihi`,
    SERVICE_INTERVAL_END_DATE: `Servis Aralığı Bitiş Tarihi`,
    SERVICE_INTERVAL_IS_REQUIRED: `Servis Aralığı Gereklidir`,
    SERVICE_INTERVAL_NUMBER: `Servis Aralığı Numarası`,
    SERVICE_INTERVAL_STATUS: `Servis Aralığı Durumu`,
    SERVICE_INTERVAL_TYPE: `Servis aralığı türü`,
    SERVICE_INTERVAL_TYPES: `Servis Aralığı Türleri`,
    SERVICE_PART: `Servis parçasi`,
    SERVICE_UNAVAILABLE: `Servis Kullanılamıyor`,
    SERVICED: `Servis Uygulandı`,
    SERVICED_DATE_IS_REQUIRED: `Servis tarihi gerekli.`,
    SERVICED_IS_REQUIRED: `Servis tarihi gerekli.`,
    SET_AS_DEFAULT: `Varsayılan olarak ayarla`,
    SETTINGS: `Ayarlarım`,
    SETTLED: `Çözüldü`,
    SETTLEMENT_NO_REGISTRATION: `Çözüm No Kaydı`,
    SETUP: `Kurulum`,
    SETUP_DATE_IS_REQUIRED: `Kurulum Tarihi gereklidir`,
    SETUP_IS_REQUIRED: `Kurulum gereklidir`,
    SGST_UTGST: `SGST/UTGST`,
    SHIP_TO: `Sevk`,
    SHIPPED: `Nakledildi`,
    SHIPPING_ID: `Sevkiyat kodu`,
    SHIPPING_ID_REQUIRED: `Sevkiyat Kodu Gerekli`,
    SHIPPING_INFORMATION_SPECIAL_INSTRUCTIONS: `Kargo Bilgileri/Özel Talimatlar`,
    SHIPPING_INSTRUCTIONS: `Nakliye Talimatları`,
    SHORT_TEXT: `Kısa metin`,
    SHORT_TEXT_IS_REQUIRED: `Kısa Metin Gerekli`,
    SHOW_ALL: `Hepsini Göster ({count})`,
    SHOW_EXCLUDED: `Hariç Bırakılanı Göster`,
    SHOW_MORE: `Daha fazla göster`,
    SHOW_MORE_GROUPS: `{countToDisplay} grup daha gösterin`,
    SHOW_RED_IF_LESS_THAN: `Daha Azsa Kırmızı Göster`,
    SHOW_REIMBURSED_AMOUNT: `Geri Ödenen Tutarı Göster`,
    SHOW_REIMBURSED_PERCENTAGE: `Geri Ödenen Yüzdesini Göster`,
    SHOW_YELLOW_IF_LESS_THAN: `Daha Azsa Sarı Göster`,
    SIGN_IN_REQUIRED: `Oturum açılması gerekiyor`,
    SIGN_OUT: `Oturumu Kapat`,
    SKIP_AUDIT: `Denetimi atla`,
    SKIP_AUDIT_SUCCESS: `Denetim atlandı ve vade tarihi artık ileride.`,
    SOME_PARTS_RETURNED: `Bazı Parçalar İade Edildi`,
    SORT_BY: `Sıralama Ölçütü`,
    SPANISH: `İspanyolca`,
    SPECIAL_ALLOWANCE: `ÖZEL ÖDENEK`,
    SPECIAL_ALLOWANCE_CALCULATION: `Özel Garanti Hesaplaması`,
    SPECIAL_ALLOWANCE_CLAIM: `Özel Ödenek Talebi`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS: `Özel Ödenek Kleymi Durumu`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_TABM: `Özel Ödenek Kleymi Durumu`,
    SPECIAL_ALLOWANCE_CLAIM_STATUS_UPDATED: `Özel Ödenek Kleymi Durumu Güncellendi`,
    SPECIAL_ALLOWANCE_CLAIM_WITH_ID: `Özel Ödenek Kleymi - {claimNumber}`,
    SPECIAL_ALLOWANCE_CLAIMS_WITH_COUNT: `Özel Ödenek Kleymi ({count})`,
    SPECIAL_ALLOWANCE_CONTRIBUTIONS: `Özel Ödenek Katkıları`,
    SPECIAL_ALLOWANCE_DESCRIPTION: `Özel Ödenek Açıklaması`,
    SPECIAL_ALLOWANCE_TYPE: `Özel Garanti Türü`,
    SPECIAL_ALLOWANCE_TYPE_IS_REQUIRED: `Özel Garanti Türü Gereklidir`,
    SPECIAL_INSTRUCTIONS: `Özel Talimatlar`,
    SPG: `SPG`,
    SPGS: `SPG'ler`,
    STANDARD_VIEW: `Genel görünüm`,
    START_AMOUNT_OF_USE: `Başlangıç Kullanım Miktarı`,
    STARTS: `Başlangıçlar`,
    STARTS_WITH: `Başlamak`,
    STATE: `Vilayet`,
    STATE_PROVINCE: `Eyalet/İl`,
    STATE_PROVINCE_REQUIRED: `Eyalet/İl Gerekli`,
    STATUS: `Durum`,
    STATUS_CHANGE_REQUEST: `Durum Değişiklik İsteği`,
    STATUS_CHANGE_REQUEST_CREATED_SUCCESSFULLY: `Durum değişiklik isteği başarıyla oluşturuldu`,
    STATUS_CHANGE_REQUEST_UPDATED_SUCCESSFULLY: `Makine Durumu İsteği güncellendi Başarılı`,
    STATUS_FOR: `{pin} için durum`,
    STATUS_INDICATOR: `Durum Göstergesi`,
    STATUS_REASON: `Durum Nedeni`,
    STOLEN_DATE: `Çalınma Tarihi`,
    STORE: `Depolama`,
    STORE_IS_REQUIRED: `Depolama gereklidir`,
    STORE_NUMBER_IS_REQUIRED: `Depolama Numarası gereklidir`,
    STREET_1: `Sokak 1`,
    STREET_2: `Sokak 2`,
    SUB: `Gönder`,
    SUB_CLAIM_TYPE: `Alt Kleym Türü`,
    SUB_TYPE: `Alt tür`,
    SUBMISSION_DATE: `Gönderme Tarihi`,
    SUBMIT: `Gönder`,
    SUBMIT_AUDIT: `Denetimi Gönder`,
    SUBMIT_AUDIT_FOR: `{dealer} İçin Denetimi Gönder`,
    SUBMIT_FULL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Tam Borç Kleymini {claimNumber} için Gönder`,
    SUBMIT_PARTIAL_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `Kısmi Borç Kleymini {claimNumber} için Gönder`,
    SUBMIT_PERCENTAGE_DEBIT_CLAIM_FOR_WITH_CLAIM_NUMBER: `{claimNumber} için Yüzde Borç Talebi Gönder`,
    SUBMIT_REQUEST: `Talebi Gönder`,
    SUBMITTED: `GÖNDERİLDİ`,
    SUBMITTED_AVAILABLE_TO_EDIT: `GÖNDERİLDİ (Düzenlenebilir)`,
    SUCCESS: `Başarı`,
    SUCCESS_MESSAGE_TITLE: `Bir işlem başarılıydı:`,
    SUCCESS_MESSAGES_TITLE: `Birden fazla işlem başarılıydı:`,
    SUPPLIER_WARRANTY: `Tedarikçi Garantisi`,
    SURVEY_QUESTIONS: `Anket Soruları`,
    SUSPENDED: `Askıya Alındı`,
    SWEDISH: `İsveççe`,
    SYSTEM_SELECTED_CLAIMS: `Sistemin Seçtiği Kleymler`,
    SYSTEM_SELECTED_CLAIMS_WITH_COUNT: `Sistemin Seçtiği Kleymler ({count})`,
    TABM: `TABM`,
    TAX: `Vergi`,
    TCSM: `TCSM`,
    TCSM_COMMENTS: `TCSM Yorumları`,
    TCSM_ID: `TCSM ID`,
    TECH_ID: `Tek. Kiml.`,
    TERMINATED: `Sonlandırıldı`,
    TERMINATES: `Sonlanır`,
    TERRITORY: `Bölge`,
    TEST: `Test`,
    TEST_RESULTS_CODE: `Test Sonuçları Kodu`,
    THEME: `Tema`,
    TIME_LIMIT: `Süre Limiti`,
    TIME_ZONE: `Zaman Dilimi`,
    TITLE: `Başlık`,
    TITLE_IS_REQUIRED: `Başlık Gerekli`,
    TO: `Bitiş`,
    TODAY: `Bugün`,
    TOO_MANY_RESULTS: `İsteğiniz çok fazla sonuç döndürdü. Lütfen arama terimlerinizi daraltın ve yeniden deneyin.`,
    TOTAL: `Toplam`,
    TOTAL_AMOUNT: `Toplam Tutar`,
    TOTAL_AMOUNT_IN_LOCAL_CURRENCY: `PLN cinsinden toplam`,
    TOTAL_APPROVED: `Onaylanan Toplamı`,
    TOTAL_APPROVED_CLAIM_VALUE: `Onaylanan Toplam Kleym Tutarı`,
    TOTAL_APPROVED_INCLUDING_TAXES: `Vergiler Dahil Toplam Onaylandı`,
    TOTAL_APPROVED_WITHOUT_ADDITIVES: `Katkılar olmadan Onaylı Toplam`,
    TOTAL_CONTRIBUTION: `Toplam Katkı`,
    TOTAL_REIMBURSED: `Geri Ödenen Toplam`,
    TOTAL_REIMBURSED_WITH_CURRENCY: `Geri Ödenen Toplamı ({currency})`,
    TOTAL_REQUESTED: `İstenen Toplamı`,
    TOTAL_REQUESTED_CLAIM_VALUE: `İstenen Toplam Kleym Tutarı`,
    TOTAL_UNPAID: `Ücretsiz Kalem Toplamı`,
    TRACKING_NUMBER: `Takip Numarası`,
    TRANSFER: `Transfer`,
    TRANSFER_ALL: `Tümünü Aktar`,
    TRANSFER_APPROVALS: `Transfer Onayları`,
    TRANSFER_APPROVALS_TAB: `Transfer Onayları ({count})`,
    TRANSFER_CREATED: `Transfer Oluşturuldu`,
    TRANSFER_DEALER_RECOMMENDATIONS: `Bayi Tavsiyelerini Aktarma`,
    TRANSFER_REJECTED: `Aktarım Reddedildi`,
    TRANSFER_UPDATED_SUCCESSFULLY: `Transfer başarıyla güncellendi`,
    TRANSFERALL_DEALER_RECOMMENDATIONS: `Tüm Bayi Önerilerini Aktarma`,
    TRANSFERS: `Transferler`,
    TRAVEL: `Nakliye`,
    TURKISH: `Türk`,
    TWO_PERCENT_WITHHOLD_VALUE: `% 2 alıkoymak Değer`,
    TYPE: `Tür`,
    TYPES: `Türler`,
    UNABLE_TO_CONTACT_THE_SERVER: `Sunucu ile iletişim kurulamıyor`,
    UNABLE_TO_COPY_ATTACHMENTS: `Ekleri orijinal talepten kopyalayamadık, lütfen yeni talebinizi göndermeden önce gözden geçirin.`,
    UNABLE_TO_LOAD_CUSTOMER_DETAILS: `Müşteri ayrıntıları yüklenemedi`,
    UNDO: `Geri Al`,
    UNDO_REGISTRATION: `Kaydı Geri Al`,
    UNDO_REGISTRATION_SUCCESSFULL: `Kaydı Geri Al Başarılı`,
    UNIT: `Birim`,
    UNIT_1: `Birim 1`,
    UNIT_2: `Birim 2`,
    UNIT_3: `Birim 3`,
    UNIT_OF_MEASURE: `Ölçü Birimi`,
    UNPAID_LABOR: `Ücretsiz İşçilik`,
    UNPAID_LABOR_ADDITIVES_EXCLUDING_PIPS: `Ödenmemiş İşçilik İlaveleri - PIP'ler Hariç`,
    UNPAID_LABOR_ADDITIVES_PIPS: `Ödenmemiş İşçilik İlaveleri - PIP'ler`,
    UNPAID_OTHER_CREDITS: `Diğer Ücretsiz Alacaklar`,
    UNPAID_PARTS: `Ücretsiz Parçalar`,
    UNPAID_PARTS_ADDITIVE: `Ödenmemiş Parçalar İlavesi`,
    UNPAID_TRAVEL: `Ücretsiz Seyahat`,
    UNRECONCIL: `Mutabakata varılmamış`,
    UNRECONCILE_CLAIM : `Mutabakata Varılmamış Kleym`,
    UNSUB: `Düzenle`,
    UNSUBMIT_CLAIM: `Düzenle Kleym`,
    UPDATE: `Güncelleştir`,
    UPDATE_CUSTOMER_INFORMATION: `Müşteri Bilgilerini Güncelle`,
    UPDATE_LABOR_RATES: `İşçilik Ücretlerini Güncelle`,
    UPDATE_LAYOUT: `Mizanpaj Güncelle`,
    UPDATE_MACHINE_STATUS: `Makine Durumunu Güncelle`,
    UPDATE_MACHINE_STATUS_HISTORY: `Makine Durumunu Güncelleme Geçmişi`,
    UPDATE_REGISTRATION: `Kaydı Güncelleştir`,
    UPDATE_SELECTED: `Seçileni Güncelleştir`,
    UPDATED: `Güncellendi`,
    UPDATED_BY: `Tarafından güncellendi`,
    UPDATED_DATE_FROM: `Güncelleme Tarihi`,
    UPDATED_DATE_TO: `Güncelleme Tarihine`,
    UPLOAD_DOCUMENT: `Belge Yükle`,
    UPTIME_ASSURANCE: `Çalışma Süresi Güvencesi`,
    USEFUL_LINKS: `Faydalı Bağlantılar`,
    USER: `kullanıcı`,
    USER_PREFERENCES_UPDATED: `Kullanıcı tercihleri güncellendi`,
    USER_SELECTED: `Kullanıcının Seçtiği`,
    USER_SELECTED_CLAIMS_WITH_COUNT: `Kullanıcının Seçtiği Kleym ({count})`,
    USERS_INFORMATION: `Kullanıcı Bilgileri`,
    VALIDATE: `Doğrula`,
    VALIDATE_CLAIM: `Talebi Doğrula`,
    VALUE: `Değer`,
    VALUE_OF_REPAIR: `Onarım Değeri`,
    VIEW_CLAIM: `Kleymi Görüntüle`,
    VIEW_DETAILS: `Ayrıntıları Görüntüle`,
    VIEW_OPEN_PIPS: `Açık PIP'leri Görüntüle`,
    VIEW_PIP: `PIP'i Görüntüle`,
    VIEW_PRODUCTS: `Ürünleri Görüntüle`,
    VIEW_PRODUCTS_AND_UPDATE_INFO: `Ürünleri Görüntüle ve Güncelleme Bilgileri`,
    VIEW_UPDATE: `Görüntüle/Güncelle`,
    VSR_MESSAGES: `VSR Mesajları`,
    WAITING_FOR_DLR_INV: `Bayi Faturası Bekliyor`,
    WAITING_FOR_INVOICE: `Fatura Bekleniyor ({count})`,
    WAITING_SINCE: `Bekleme Süresi`,
    WARNING_MESSAGE_TITLE: `Bir uyarı gönderildi:`,
    WARNING_MESSAGES: `Uyarı Mesajları`,
    WARNING_MESSAGES_TITLE: `Birden fazla uyarı gönderildi:`,
    WARRANTY: `Garanti`,
    WARRANTY_ADMIN: `Garanti Yöneticisi`,
    WARRANTY_CLAIM_TYPE: `Garanti Talep Türü`,
    WARRANTY_COVERAGE: `Garanti Kapsamı`,
    WARRANTY_EXPIRATION: `Garanti Süre Sonu`,
    WARRANTY_TYPE: `Garanti Türü`,
    WARRANTY_TYPES: `Garanti Türleri`,
    WEAR_PARTS: `Parça Takma`,
    WEAR_PARTS_COVERAGE: `Parça Kapsamı`,
    WELCOME: `Hoş Geldiniz`,
    WINTERIZATION: `Kışlık`,
    WIP: `İş Devam Ediyor`,
    WITH_ADDITIVES: `İlaveler İle`,
    WITNESS_FIRST_NAME: `Şahit Adı`,
    WITNESS_LAST_NAME: `Şahit Soyadı`,
    WORK_ORDER: `İş Emri`,
    WORK_ORDER_NUMBER: `İş Emri Numarası`,
    WORK_ORDER_ONE: `İş Emri 1`,
    WORK_ORDER_ONE_IS_REQUIRED: `İş Emri 1 gereklidir`,
    WORK_ORDER_THREE: `İş Emri 3`,
    WORK_ORDER_THREE_IS_REQUIRED: `İş Emri 3 gereklidir`,
    WORK_ORDER_TWO: `İş Emri 2`,
    WORK_REPAIR_ORDER: `İş Tamir Siparişi`,
    YES: `Evet`,
    YES_LOWERCASE: `Evet`
});



// WEBPACK FOOTER //
// ./~/@deere/cps-it.warranty-i18n/lib/tr.js